import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc, collection, onSnapshot, deleteDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCOM41RPcxgBEHEWCJTBStSanpIUKyVG9g",
  authDomain: "falafel-albayt.firebaseapp.com",
  projectId: "falafel-albayt",
  storageBucket: "falafel-albayt.firebasestorage.app",
  messagingSenderId: "201946555846",
  appId: "1:201946555846:web:82316a899c9b8e13e8bec7",
  measurementId: "G-914C65XVP9"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

// ─── AUTH CONFIG ──────────────────────────────────────────────────────────────
const PASSWORDS = {
  "falafel2026admin": "admin",
  "falafel2026view": "viewer",
};

// ═══════════════════════════════════════════════════════════════════════════════
// MASTER DATA
// ═══════════════════════════════════════════════════════════════════════════════
const MENU_CATEGORIES = [
  { id: "sandwitchat_falafel", name: "Sandwitchat Al Falafel", nameAr: "سندوتشات الفلافل", emoji: "🥙",
    items: [
      { id: "f1", name: "Falafel Al Sari3", nameAr: "فلافل السريع", price: 4 },
      { id: "f2", name: "Falafel Shamiyah", nameAr: "فلافل شامية", price: 5 },
      { id: "f3", name: "Falafel Shamiyah Dbl", nameAr: "فلافل شامية دبل", price: 6.5 },
      { id: "f4", name: "Falafel Al Bayt", nameAr: "فلافل البيت", price: 6 },
      { id: "f5", name: "Falafel Al Bayt Dbl", nameAr: "فلافل البيت دبل", price: 7 },
      { id: "f6", name: "Falafel Mozzarella", nameAr: "فلافل موزاريلا", price: 8 },
    ]},
  { id: "sandwitchat_foul", name: "Sandwitchat Al Foul", nameAr: "سندوتشات الفول", emoji: "🫘",
    items: [
      { id: "fo1", name: "Foul Bzeit Zeitoun", nameAr: "فول بزيت زيتون", price: 4 },
      { id: "fo2", name: "Foul Bel Tahina", nameAr: "فول بالطحينة", price: 5 },
      { id: "fo3", name: "Foul Iskandarani (Har)", nameAr: "فول إسكندراني (حار)", price: 6 },
      { id: "fo4", name: "Foul W Falafel Mix", nameAr: "فول وفلافل مكس", price: 6 },
      { id: "fo5", name: "Foul Bkhalta Al Tamatem", nameAr: "فول بخلطة الطماطم", price: 5 },
    ]},
  { id: "sohoun", name: "Sohoun", nameAr: "صحون", emoji: "🍽",
    items: [
      { id: "s1", name: "Sahn Mesabha", nameAr: "صحن مسبحة", price: 6 },
      { id: "s2", name: "Sahn Foul Bzeit Zeitoun", nameAr: "صحن فول بزيت زيتون", price: 5 },
      { id: "s3", name: "Sahn Foul Bel Tahina", nameAr: "صحن فول بالطحينة", price: 7 },
      { id: "s4", name: "Sahn Foul Iskandarani (Har)", nameAr: "صحن فول إسكندراني (حار)", price: 7 },
      { id: "s5", name: "Sahn Foul Bkhalta Al Tamatem", nameAr: "صحن فول بخلطة الطماطم", price: 6 },
      { id: "s6", name: "Sahn Foul Bel Semneh", nameAr: "صحن فول بالسمنة", price: 7 },
      { id: "s7", name: "Sahn Fatta Hummus", nameAr: "صحن فتة حمص", price: 10 },
    ]},
  { id: "wejbat_falafel", name: "Wejbat Al Falafel", nameAr: "وجبات الفلافل", emoji: "🥗",
    items: [
      { id: "w1", name: "Wejba Al Bayt Fardi", nameAr: "وجبة البيت فردي", price: 12 },
      { id: "w2", name: "Wejba Al Bayt Zawgi", nameAr: "وجبة البيت زوجي", price: 15 },
      { id: "w3", name: "Wejba Al Bayt Family", nameAr: "وجبة البيت عائلية", price: 20 },
      { id: "w4", name: "Wejba Al Bayt Family Max", nameAr: "وجبة البيت عائلية ماكس", price: 22 },
    ]},
  { id: "aqras_falafel", name: "Aqras Al Falafel", nameAr: "أقراص الفلافل", emoji: "🧆",
    items: [
      { id: "a1", name: "Kees Falafel", nameAr: "كيس فلافل", price: 1 },
      { id: "a2", name: "Kees Falafel Bel Simsim", nameAr: "كيس فلافل بالسمسم", price: 1 },
      { id: "a3", name: "Pop Corn Falafel", nameAr: "بوب كورن فلافل", price: 5 },
    ]},
  { id: "mashroubat", name: "Mashroubat", nameAr: "مشروبات", emoji: "🥤",
    items: [
      { id: "m1", name: "Qreen Cola", nameAr: "قرين كولا", price: 4 },
      { id: "m2", name: "Al Ain Cola", nameAr: "العين كولا", price: 3 },
      { id: "m3", name: "Water", nameAr: "ماء", price: 1 },
    ]},
  { id: "idafat", name: "Idafat", nameAr: "إضافات", emoji: "➕",
    items: [
      { id: "i1", name: "Jibna Slides", nameAr: "جبنة شرائح", price: 1 },
      { id: "i2", name: "Mkhallal Khyar", nameAr: "مخلل خيار", price: 1 },
      { id: "i3", name: "Mesabha", nameAr: "مسبحة", price: 1 },
    ]},
];

const ALL_MENU_ITEMS = MENU_CATEGORIES.flatMap((c) =>
  c.items.map((i) => ({ ...i, categoryId: c.id, categoryName: c.name, categoryNameAr: c.nameAr, categoryEmoji: c.emoji }))
);

const PROCUREMENT_CATEGORIES = [
  { id: "vegetables", name: "Vegetables", nameAr: "خضروات", emoji: "🥬", unit: "kg",
    items: [
      { id: "v1", name: "Salata", nameAr: "سلاطة" },
      { id: "v2", name: "Tamatem", nameAr: "طماطم" },
      { id: "v3", name: "Bathenjan", nameAr: "باذنجان" },
      { id: "v4", name: "Batata", nameAr: "بطاطا" },
      { id: "v5", name: "Toma", nameAr: "توم" },
      { id: "v6", name: "Haressa", nameAr: "هريسة" },
    ]},
  { id: "packaging", name: "Packaging", nameAr: "تغليف", emoji: "📦", unit: "pcs",
    items: [
      { id: "p1", name: "Gloves", nameAr: "قفازات" },
      { id: "p2", name: "Boxes", nameAr: "علب" },
      { id: "p3", name: "Sauce Mini Box", nameAr: "علبة صوص صغيرة" },
      { id: "p4", name: "Paper Roll", nameAr: "ورق رول" },
      { id: "p5", name: "Cheese Slides", nameAr: "شرائح جبن" },
      { id: "p6", name: "French Fries", nameAr: "بطاطس مجمدة" },
      { id: "p7", name: "Basales Bags", nameAr: "أكياس بصل" },
      { id: "p8", name: "Silver Plates", nameAr: "صحون فضية" },
      { id: "p9", name: "Paper Sandwitch", nameAr: "ورق ساندوتش" },
      { id: "p10", name: "Falafel Bags", nameAr: "أكياس فلافل" },
    ]},
  { id: "materials", name: "Materials", nameAr: "مواد", emoji: "🫙", unit: "kg",
    items: [
      { id: "mat1", name: "Hummus", nameAr: "حمص" },
      { id: "mat2", name: "Oil", nameAr: "زيت" },
      { id: "mat3", name: "Tahini", nameAr: "طحينة" },
      { id: "mat4", name: "Spices", nameAr: "بهارات" },
      { id: "mat5", name: "Water Jugs", nameAr: "ماء جرادل" },
      { id: "mat6", name: "Foul", nameAr: "فول" },
    ]},
];

const MONTHLY_RENTS = [
  { id: "r1", name: "Store Rent", amount: 3200 },
  { id: "r2", name: "Lab Rent", amount: 1080 },
  { id: "r3", name: "House Rent", amount: 800 },
];

const INITIAL_STAFF = [
  { id: "st1", name: "Abu Moneer", nameAr: "أبو منير", type: "daily", dailyRate: 150, monthlyRate: null, role: "Kitchen", loans: [] },
  { id: "st2", name: "Hammouda", nameAr: "حمودة", type: "daily", dailyRate: 95, monthlyRate: null, role: "Kitchen", loans: [] },
  { id: "st3", name: "Abdullah Souri", nameAr: "عبدالله سوري", type: "daily", dailyRate: 80, monthlyRate: null, role: "Kitchen", loans: [] },
  { id: "st4", name: "Omar Souri", nameAr: "عمر سوري", type: "daily", dailyRate: 80, monthlyRate: null, role: "Kitchen", loans: [] },
  { id: "st5", name: "Abdo", nameAr: "عبده", type: "monthly", dailyRate: null, monthlyRate: 1100, role: "Cashier", loans: [] },
  { id: "st6", name: "Zakarya", nameAr: "زكريا", type: "monthly", dailyRate: null, monthlyRate: 750, role: "Cashier", loans: [] },
  { id: "st7", name: "Abdullah", nameAr: "عبدالله", type: "monthly", dailyRate: null, monthlyRate: 1000, role: "Cleaner", loans: [] },
  { id: "st8", name: "Ibrahim", nameAr: "إبراهيم", type: "monthly", dailyRate: null, monthlyRate: 1200, role: "Cleaner", loans: [] },
  { id: "st9", name: "Hussam", nameAr: "حسام", type: "monthly", dailyRate: null, monthlyRate: 1350, role: "Procurement", loans: [] },
];

// ═══════════════════════════════════════════════════════════════════════════════
// THEME — Comfortable Light Navy (easy on the eyes)
// ═══════════════════════════════════════════════════════════════════════════════
const T = {
  bg:          "#1B2B4B",   // comfortable medium navy
  surface:     "#223259",   // slightly lighter surface
  card:        "#2A3D6B",   // card — clearly distinct from surface
  cardHover:   "#304673",
  border:      "#3A5080",   // visible but soft border
  accent:      "#4D9FFF",   // bright readable blue
  accentLight: "#82BFFF",   // light blue for secondary values
  accentGlow:  "#4D9FFF33",
  green:       "#2EE8A6",   // bright teal-green
  red:         "#FF6B7A",   // soft red
  yellow:      "#FFD166",   // warm yellow
  teal:        "#22D3EE",   // cyan teal
  purple:      "#A78BFA",   // soft purple
  text:        "#EEF4FF",   // near white with blue tint — very readable
  muted:       "#8BA5CC",   // clearly readable muted — not too dark
  white:       "#FFFFFF",
};

// ═══════════════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════════════
const fmt = (n) =>
  `${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} LYD`;
const today = () => new Date().toISOString().split("T")[0];
const todayLabel = () =>
  new Date().toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
const monthKey = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
const dateLabel = (d) =>
  new Date(d + "T12:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" });
function genId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

// ═══════════════════════════════════════════════════════════════════════════════
// FIREBASE STORE
// ═══════════════════════════════════════════════════════════════════════════════
function useStore(key, init) {
  const [val, setVal] = useState(typeof init === "function" ? init() : init);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const ref = doc(db, "appData", key);
    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        setVal(snap.data().value);
      }
      setLoaded(true);
    });
    return () => unsub();
  }, [key]);

  const set = useCallback((v) => {
    setVal((prev) => {
      const next = typeof v === "function" ? v(prev) : v;
      setDoc(doc(db, "appData", key), { value: next });
      return next;
    });
  }, [key]);

  return [val, set];
}



// ═══════════════════════════════════════════════════════════════════════════════
// UI PRIMITIVES
// ═══════════════════════════════════════════════════════════════════════════════
const Badge = ({ children, color = T.accent, small }) => (
  <span style={{
    background: color + "22", color, padding: small ? "2px 8px" : "3px 12px",
    borderRadius: 999, fontSize: small ? 10 : 11, fontWeight: 700,
    letterSpacing: 0.4, whiteSpace: "nowrap", border: `1px solid ${color}44`,
  }}>{children}</span>
);

const Pill = ({ label, active, onClick, color }) => (
  <button onClick={onClick} style={{
    background: active ? (color || T.accent) : T.card,
    color: active ? T.white : T.muted,
    border: `1px solid ${active ? (color || T.accent) : T.border}`,
    borderRadius: 10, padding: "8px 18px", cursor: "pointer",
    fontWeight: 600, fontSize: 13, transition: "all 0.15s", fontFamily: "inherit",
    boxShadow: active ? `0 0 14px ${(color || T.accent)}44` : "none",
  }}>{label}</button>
);

const Input = ({ label, ...props }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
    {label && <label style={{ fontSize: 11, fontWeight: 700, color: T.muted, letterSpacing: 1, textTransform: "uppercase" }}>{label}</label>}
    <input {...props} style={{
      background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10,
      color: T.text, padding: "10px 14px", fontSize: 14, outline: "none",
      width: "100%", boxSizing: "border-box", fontFamily: "inherit", ...props.style,
    }} />
  </div>
);

const Select = ({ label, children, ...props }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
    {label && <label style={{ fontSize: 11, fontWeight: 700, color: T.muted, letterSpacing: 1, textTransform: "uppercase" }}>{label}</label>}
    <select {...props} style={{
      background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10,
      color: T.text, padding: "10px 14px", fontSize: 14, outline: "none",
      width: "100%", boxSizing: "border-box", fontFamily: "inherit", ...props.style,
    }}>{children}</select>
  </div>
);

const Btn = ({ children, onClick, variant = "primary", small, full, disabled, color }) => {
  const bg = color || (variant === "primary" ? T.accent : variant === "danger" ? T.red : variant === "ghost" ? "transparent" : T.card);
  const col = variant === "ghost" ? T.muted : T.white;
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background: bg, color: col,
      border: variant === "ghost" ? `1px solid ${T.border}` : "none",
      borderRadius: 10, padding: small ? "7px 14px" : "11px 22px",
      fontWeight: 700, fontSize: small ? 12 : 14, cursor: disabled ? "not-allowed" : "pointer",
      width: full ? "100%" : "auto", opacity: disabled ? 0.5 : 1, fontFamily: "inherit",
      boxShadow: (variant === "primary" || color) && !disabled ? `0 0 18px ${(color || T.accent)}55` : "none",
    }}>{children}</button>
  );
};

const KPICard = ({ label, value, sub, color = T.accent, icon, trend }) => (
  <div style={{
    background: T.card, border: `1px solid ${T.border}`, borderRadius: 16,
    padding: "18px 20px", flex: 1, minWidth: 150,
    boxShadow: `0 4px 24px ${color}11`,
  }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
      <span style={{ fontSize: 24 }}>{icon}</span>
      {trend !== undefined && (
        <span style={{ fontSize: 11, fontWeight: 700, color: trend >= 0 ? T.green : T.red }}>
          {trend >= 0 ? "▲" : "▼"} {Math.abs(trend).toFixed(1)}%
        </span>
      )}
    </div>
    <div style={{ fontSize: 21, fontWeight: 800, color, fontFamily: "monospace", letterSpacing: -0.5 }}>{value}</div>
    <div style={{ color: T.muted, fontSize: 11, marginTop: 4, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
    {sub && <div style={{ color, fontSize: 12, marginTop: 2, opacity: 0.8 }}>{sub}</div>}
  </div>
);

function Toast({ msg, type }) {
  return (
    <div style={{
      position: "fixed", bottom: 28, left: "50%", transform: "translateX(-50%)",
      background: type === "success" ? T.green : type === "error" ? T.red : T.accent,
      color: "#fff", padding: "13px 26px", borderRadius: 14, fontWeight: 700, zIndex: 9999,
      boxShadow: "0 8px 40px rgba(0,0,0,0.6)", fontSize: 14, whiteSpace: "nowrap",
    }}>{msg}</div>
  );
}

function Modal({ title, onClose, children }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000099", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(4px)" }}>
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 20, padding: 28, maxWidth: 540, width: "100%", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.7)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
          <div style={{ fontWeight: 800, fontSize: 17 }}>{title}</div>
          <button onClick={onClose} style={{ background: T.card, border: "none", color: T.muted, fontSize: 18, cursor: "pointer", borderRadius: 8, width: 34, height: 34 }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function MiniBarChart({ data, colorFn, height = 80 }) {
  const max = Math.max(...data.map((d) => Math.abs(d.value)), 1);
  const [tooltip, setTooltip] = useState(null);
  return (
    <div style={{ position: "relative" }}>
      {tooltip && (
        <div style={{
          position: "absolute", bottom: height + 10,
          left: `${tooltip.pct}%`, transform: "translateX(-50%)",
          background: T.surface, border: `1px solid ${T.border}`,
          borderRadius: 8, padding: "6px 10px", zIndex: 50,
          whiteSpace: "nowrap", pointerEvents: "none",
          boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
        }}>
          <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>{dateLabel(tooltip.date)}</div>
          <div style={{ color: tooltip.value >= 0 ? T.green : T.red, fontWeight: 800, fontFamily: "monospace", fontSize: 13 }}>
            {fmt(tooltip.value)}
          </div>
        </div>
      )}
      <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height }}>
        {data.map((d, i) => (
          <div key={i}
            onMouseEnter={() => setTooltip({ date: d.date, value: d.value, pct: (i / data.length) * 100 + (50 / data.length) })}
            onMouseLeave={() => setTooltip(null)}
            onTouchStart={() => setTooltip({ date: d.date, value: d.value, pct: (i / data.length) * 100 + (50 / data.length) })}
            onTouchEnd={() => setTimeout(() => setTooltip(null), 1500)}
            style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", height: "100%", cursor: "pointer" }}>
            <div style={{
              width: "100%", height: `${(Math.abs(d.value) / max) * (height - 8)}px`,
              background: colorFn ? colorFn(d) : T.accent + "AA",
              borderRadius: "3px 3px 0 0", minHeight: 2,
            }} />
          </div>
        ))}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// DASHBOARD
// ═══════════════════════════════════════════════════════════════════════════════
function Dashboard({ salesRecords, procRecords, wageRecords, monthlyExpenses, staff, settings, menuCategories }) {
  const [fromDate, setFromDate] = useState(`${monthKey()}-01`);
  const [toDate, setToDate] = useState(today());

  const stats = useMemo(() => {
    const fSales = Object.values(salesRecords).filter((r) => r.date >= fromDate && r.date <= toDate);
    const fProc  = Object.values(procRecords).filter((r) => r.date >= fromDate && r.date <= toDate);
    const fWages = Object.values(wageRecords).filter((r) => r.date >= fromDate && r.date <= toDate);

    const dashMenuItems = menuCategories ? menuCategories.flatMap((c) => c.items) : ALL_MENU_ITEMS;
    let storeSales = 0, prestoSales = 0, prestoCommTotal = 0;
    fSales.forEach((r) => {
      dashMenuItems.forEach((item) => {
        storeSales += (r.storeItems?.[item.id] || 0) * item.price;
      });
      (r.prestoEntries || []).forEach((e) => {
        prestoSales += e.amount;
        prestoCommTotal += e.amount * e.commission / 100;
      });
    });
    const totalRevenue = storeSales;

    let procCost = 0;
    fProc.forEach((r) => r.items?.forEach((i) => { procCost += Number(i.qty) * Number(i.cost); }));
    let wagesCost = 0;
    fWages.forEach((r) => r.wages?.forEach((w) => { if (w.present) wagesCost += Number(w.amount) || 0; }));
    const mo = monthKey();
    const monthExp = monthlyExpenses.filter((e) => e.yearMonth === mo).reduce((a, e) => a + Number(e.amount), 0);
    const totalExpenses = procCost + wagesCost + monthExp;
    const grossProfit = totalRevenue - procCost;
    const netProfit = totalRevenue - totalExpenses - prestoCommTotal;
    const netMargin = totalRevenue > 0 ? (netProfit / totalRevenue) * 100 : 0;
    const grossMargin = totalRevenue > 0 ? (grossProfit / totalRevenue) * 100 : 0;

    const allDates = [];
    const start = new Date(fromDate);
    const end = new Date(toDate);
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      allDates.push(d.toISOString().split("T")[0]);
    }
    const dailyProfit = allDates.map((date) => {
      const s = salesRecords[date];
      let rev = 0;
      if (s) {
        dashMenuItems.forEach((item) => {
          rev += (s.storeItems?.[item.id] || 0) * item.price;
        });
      }
      return { date, value: rev };
    });

    const allItems = menuCategories ? menuCategories.flatMap((c) => c.items) : ALL_MENU_ITEMS;
    const itemSales = {};
    fSales.forEach((r) => {
      allItems.forEach((item) => {
        const qty = (r.storeItems?.[item.id] || 0);
        if (qty) {
          if (!itemSales[item.id]) itemSales[item.id] = { name: item.name, qty: 0, rev: 0 };
          itemSales[item.id].qty += qty;
          itemSales[item.id].rev += qty * item.price;
        }
      });
    });
    const topItems = Object.values(itemSales).sort((a, b) => b.rev - a.rev).slice(0, 8);
    const expBreakdown = [
      { label: "Procurement", value: procCost, color: T.yellow },
      { label: "Daily Wages", value: wagesCost, color: T.teal },
      { label: "Monthly Expenses", value: monthExp, color: T.purple },
    ];
    return {
      storeSales, prestoSales, prestoCommTotal,
      prestoNet: prestoSales - prestoCommTotal,
      totalRevenue, procCost, wagesCost, monthExp,
      totalExpenses, grossProfit, netProfit, netMargin, grossMargin,
      dailyProfit, topItems, expBreakdown,
      daysWithSales: fSales.length,
      avgDailyRevenue: fSales.length > 0 ? totalRevenue / fSales.length : 0,
    };
  }, [salesRecords, procRecords, wageRecords, monthlyExpenses, fromDate, toDate, settings, menuCategories]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Business Dashboard</div>
          <div style={{ color: T.muted, fontSize: 13 }}>{todayLabel()}</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: T.muted, fontSize: 13 }}>From:</span>
            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)}
              style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "7px 12px", fontSize: 13, fontFamily: "inherit" }} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: T.muted, fontSize: 13 }}>To:</span>
            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)}
              style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "7px 12px", fontSize: 13, fontFamily: "inherit" }} />
          </div>
        </div>
      </div>

      {/* KPI Row 1 */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <KPICard icon="💰" label="Total Sales"  value={fmt(stats.totalRevenue)}  color={T.accent}  sub={`${stats.daysWithSales} days recorded`} />
        <KPICard icon="📤" label="Total Expenses" value={fmt(stats.totalExpenses)} color={T.red} />
        <KPICard icon="📊" label="Gross Profit"   value={fmt(stats.grossProfit)}   color={T.yellow}  sub={`Margin: ${stats.grossMargin.toFixed(1)}%`} />
        <KPICard icon="🏆" label="Net Profit"     value={fmt(stats.netProfit)}     color={stats.netProfit >= 0 ? T.green : T.red} sub={`Net Margin: ${stats.netMargin.toFixed(1)}%`} />
      </div>

      {/* KPI Row 2 */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <KPICard icon="🏪" label="Store Sales"       value={fmt(stats.storeSales)}      color={T.accentLight} />
        <KPICard icon="🛵" label="Presto Sales"      value={fmt(stats.prestoSales)}     color={T.teal} />
        <KPICard icon="🤝" label="Presto Commission Fee" value={fmt(stats.prestoCommTotal)} color={T.muted} />
        <KPICard icon="📈" label="Avg Daily Sales" value={fmt(stats.avgDailyRevenue)} color={T.purple} />
        <KPICard icon="📉" label="Avg Daily Expenses" value={fmt(stats.daysWithSales > 0 ? stats.totalExpenses / stats.daysWithSales : 0)} color={T.red} />
      </div>

      {/* Chart + Expense Breakdown */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20, flex: 2, minWidth: 260 }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Total Daily Sales — {fromDate} to {toDate}</div>
          <div style={{ color: T.muted, fontSize: 12, marginBottom: 14 }}>Sales per day</div>
          <MiniBarChart
            data={stats.dailyProfit}
            colorFn={(d) => d.value > 0 ? T.accent + "CC" : T.border}
            height={90}
          />
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, color: T.muted, fontSize: 11 }}>
            <span>{fromDate}</span><span>{toDate}</span>
          </div>
        </div>
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20, flex: 1, minWidth: 220 }}>
          <div style={{ fontWeight: 700, marginBottom: 16 }}>Expense Breakdown</div>
          {stats.expBreakdown.map((e) => {
            const pct = stats.totalExpenses > 0 ? (e.value / stats.totalExpenses) * 100 : 0;
            return (
              <div key={e.label} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5, fontSize: 13 }}>
                  <span style={{ fontWeight: 600 }}>{e.label}</span>
                  <span style={{ color: e.color, fontWeight: 700, fontFamily: "monospace" }}>{fmt(e.value)}</span>
                </div>
                <div style={{ background: T.border, borderRadius: 99, height: 6 }}>
                  <div style={{ background: e.color, width: `${pct}%`, height: 6, borderRadius: 99 }} />
                </div>
                <div style={{ color: T.muted, fontSize: 11, marginTop: 2 }}>{pct.toFixed(1)}% of total</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Sales Channel Comparison */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>Sales Channel Comparison</div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {[
            { label: "Store Sales",             value: stats.storeSales,      color: T.accent },
            { label: "Presto Sales",            value: stats.prestoSales,     color: T.teal },
            { label: "Presto Net (After Fee)",  value: stats.prestoNet,       color: T.green },
            { label: "Presto Commission Fee",   value: stats.prestoCommTotal, color: T.muted },
          ].map((c) => (
            <div key={c.label} style={{ flex: 1, minWidth: 140, background: T.surface, borderRadius: 12, padding: 16, border: `1px solid ${T.border}` }}>
              <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>{c.label}</div>
              <div style={{ fontSize: 17, fontWeight: 800, color: c.color, fontFamily: "monospace" }}>{fmt(c.value)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Top Items */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>Top Selling Items</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {stats.topItems.map((item, i) => {
            const maxRev = stats.topItems[0]?.rev || 1;
            return (
              <div key={item.name} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ color: T.muted, fontSize: 12, fontWeight: 700, width: 20, textAlign: "right" }}>{i + 1}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, fontSize: 13 }}>
                    <span style={{ fontWeight: 600 }}>{item.name}</span>
                    <span style={{ color: T.accent, fontFamily: "monospace", fontWeight: 700 }}>
                      {fmt(item.rev)} <span style={{ color: T.muted, fontWeight: 400 }}>({item.qty} sold)</span>
                    </span>
                  </div>
                  <div style={{ background: T.border, borderRadius: 99, height: 5 }}>
                    <div style={{ background: `linear-gradient(90deg, ${T.accent}, ${T.accentLight})`, width: `${(item.rev / maxRev) * 100}%`, height: 5, borderRadius: 99 }} />
                  </div>
                </div>
              </div>
            );
          })}
          {stats.topItems.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No sales recorded yet</div>}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// SALES ENTRY — ALL CATEGORIES VISIBLE, STICKY JUMP BAR
// ═══════════════════════════════════════════════════════════════════════════════
function SalesEntry({ salesRecords, setSalesRecords, settings, showToast, menuCategories, role }) {
  const [date, setDate] = useState(today());
  const [channel, setChannel] = useState("store");
  const [prestoCommission, setPrestoCommission] = useState(settings.prestoCommission || 20);
  const [storeItems, setStoreItems] = useState({});
  const [prestoDirectAmount, setPrestoDirectAmount] = useState("");
  const [prestoEntries, setPrestoEntries] = useState([]);
  const [note, setNote] = useState("");
  const [activeJump, setActiveJump] = useState(MENU_CATEGORIES[0].id);
  const sectionRefs = useRef({});

  useEffect(() => {
    setStoreItems({});
    setPrestoDirectAmount("");
    setPrestoEntries([]);
    setNote("");
  }, [date]);

  // Show saved presto entries when viewing a date that has data
  const savedPrestoEntries = salesRecords[date]?.prestoEntries || [];

  const items = storeItems;
  const setItems = setStoreItems;

  const setQty = (id, qty) => {
    setItems((prev) => {
      const next = { ...prev };
      if (qty <= 0) delete next[id]; else next[id] = qty;
      return next;
    });
  };

  const totals = useMemo(() => {
    let storeTotal = 0;
    menuCategories.flatMap((c) => c.items).forEach((item) => {
      storeTotal += (storeItems[item.id] || 0) * item.price;
    });
    const prestoTotal = prestoEntries.reduce((a, e) => a + e.amount, 0);
    const prestoCommAmt = prestoEntries.reduce((a, e) => a + e.amount * e.commission / 100, 0);

    // Also calculate existing saved totals for this date
    const existing = salesRecords[date];
    let savedStore = 0, savedPresto = 0;
    if (existing) {
      menuCategories.flatMap((c) => c.items).forEach((item) => {
        savedStore += (existing.storeItems?.[item.id] || 0) * item.price;
      });
      savedPresto = (existing.prestoEntries || []).reduce((a, e) => a + e.amount, 0);
    }

    return { storeTotal, prestoTotal, prestoCommAmt, grandTotal: storeTotal, savedStore, savedPresto, savedTotal: savedStore };
  }, [storeItems, prestoEntries, menuCategories, salesRecords, date]);

  const jumpTo = (catId) => {
    setActiveJump(catId);
    const el = sectionRefs.current[catId];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // Track which section is in view
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActiveJump(entry.target.dataset.catid);
      });
    }, { rootMargin: "-30% 0px -60% 0px" });
    Object.values(sectionRefs.current).forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  const save = () => {
    if (totals.grandTotal === 0 && prestoEntries.length === 0) { showToast("Please record at least one item", "error"); return; }
    setSalesRecords((prev) => {
      const existing = prev[date];
      if (existing) {
        const mergedStore = { ...existing.storeItems };
        Object.entries(storeItems).forEach(([id, qty]) => {
          mergedStore[id] = (mergedStore[id] || 0) + qty;
        });
        const mergedPrestoEntries = [...(existing.prestoEntries || []), ...prestoEntries];
        return { ...prev, [date]: { date, storeItems: mergedStore, prestoEntries: mergedPrestoEntries, note } };
      }
      return { ...prev, [date]: { date, storeItems, prestoEntries, note } };
    });
    setStoreItems({});
    setPrestoDirectAmount("");
    setPrestoEntries([]);
    setNote("");
    showToast("Sales saved! Fields reset for next shift ✅", "success");
  };

  const deleteSales = () => {
    setSalesRecords((prev) => {
      const next = { ...prev };
      delete next[date];
      return next;
    });
    setStoreItems({});
    setPrestoDirectAmount("");
    setPrestoEntries([]);
    setNote("");
    showToast("Sales record deleted!", "success");
  };

  const totalSelected = Object.values(items).reduce((a, v) => a + v, 0);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Record Daily Sales</div>
          <div style={{ color: T.muted, fontSize: 13 }}>Scroll through all items — no tab switching needed</div>
        </div>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
          style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
      </div>

      {/* Channel */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 14, display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ display: "flex", gap: 8 }}>
          <Pill label="🏪 In-Store" active={channel === "store"} onClick={() => setChannel("store")} color={T.accent} />
          <Pill label="🛵 Presto Delivery" active={channel === "presto"} onClick={() => setChannel("presto")} color={T.teal} />
        </div>
        {channel === "store" && totalSelected > 0 && (
          <span style={{ marginLeft: "auto", color: T.green, fontWeight: 700, fontSize: 13 }}>
            {totalSelected} items selected
          </span>
        )}
      </div>

      {/* ── PRESTO SIMPLE INPUT ──────────────────────────────────────────────── */}
      {channel === "presto" && (
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ fontWeight: 700, fontSize: 16 }}>🛵 Presto Delivery Sales</div>
          <div style={{ color: T.muted, fontSize: 13 }}>Enter each Presto batch separately with its commission rate</div>

          {/* New Entry Input */}
          <div style={{ background: T.surface, borderRadius: 12, padding: 16, display: "flex", flexDirection: "column", gap: 12 }}>
            <Input
              label="Presto Sales Amount (LYD)"
              type="number"
              placeholder="0"
              value={prestoDirectAmount}
              onChange={(e) => setPrestoDirectAmount(e.target.value)}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <span style={{ color: T.muted, fontSize: 13 }}>Commission:</span>
              {[15, 20, 25, 30].map((p) => (
                <button key={p} onClick={() => setPrestoCommission(p)} style={{
                  background: prestoCommission === p ? T.teal : T.surface,
                  color: prestoCommission === p ? T.white : T.muted,
                  border: `1px solid ${prestoCommission === p ? T.teal : T.border}`,
                  borderRadius: 8, padding: "5px 12px", cursor: "pointer",
                  fontWeight: 700, fontSize: 13, fontFamily: "inherit",
                }}>{p}%</button>
              ))}
              <input
                type="number" min="0" max="100" placeholder="Custom %"
                value={[15, 20, 25, 30].includes(prestoCommission) ? "" : prestoCommission}
                onChange={(e) => setPrestoCommission(Number(e.target.value))}
                style={{ background: T.surface, border: `1px solid ${![15, 20, 25, 30].includes(prestoCommission) ? T.teal : T.border}`, borderRadius: 8, color: T.text, padding: "5px 10px", fontSize: 13, fontFamily: "inherit", width: 90, outline: "none" }}
              />
              <span style={{ color: T.muted, fontSize: 13 }}>%</span>
            </div>
            {Number(prestoDirectAmount) > 0 && (
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <div style={{ flex: 1, background: T.card, borderRadius: 8, padding: 10 }}>
                  <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>COMMISSION</div>
                  <div style={{ color: T.red, fontWeight: 800, fontFamily: "monospace" }}>{fmt(Number(prestoDirectAmount) * (prestoCommission / 100))}</div>
                </div>
                <div style={{ flex: 1, background: T.card, borderRadius: 8, padding: 10 }}>
                  <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>NET DUE</div>
                  <div style={{ color: T.green, fontWeight: 800, fontFamily: "monospace" }}>{fmt(Number(prestoDirectAmount) * (1 - prestoCommission / 100))}</div>
                </div>
              </div>
            )}
            <button onClick={() => {
              if (!prestoDirectAmount || Number(prestoDirectAmount) <= 0) return;
              setPrestoEntries((prev) => [...prev, { id: genId(), amount: Number(prestoDirectAmount), commission: prestoCommission }]);
              setPrestoDirectAmount("");
            }} style={{ background: T.teal, border: "none", color: "#000", borderRadius: 8, padding: "10px", cursor: "pointer", fontWeight: 700, fontSize: 14, fontFamily: "inherit" }}>
              + Add This Entry
            </button>
          </div>

          {/* Entries List */}
          {prestoEntries.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: T.muted }}>TODAY'S PRESTO ENTRIES:</div>
              {prestoEntries.map((entry) => (
                <div key={entry.id} style={{ background: T.surface, borderRadius: 10, padding: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <span style={{ fontFamily: "monospace", fontWeight: 700, color: T.teal }}>{fmt(entry.amount)}</span>
                    <span style={{ color: T.muted, fontSize: 12, marginLeft: 8 }}>@ {entry.commission}% commission</span>
                  </div>
                  <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                    <span style={{ color: T.red, fontSize: 12, fontFamily: "monospace" }}>-{fmt(entry.amount * entry.commission / 100)}</span>
                    <span style={{ color: T.green, fontFamily: "monospace", fontWeight: 700 }}>{fmt(entry.amount * (1 - entry.commission / 100))}</span>
                    <button onClick={() => setPrestoEntries((prev) => prev.filter((e) => e.id !== entry.id))}
                      style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 6, padding: "3px 8px", cursor: "pointer", fontSize: 12, fontFamily: "inherit" }}>×</button>
                  </div>
                </div>
              ))}
              {/* Totals */}
              <div style={{ background: T.card, borderRadius: 10, padding: 12, display: "flex", gap: 12, flexWrap: "wrap", borderTop: `2px solid ${T.border}` }}>
                <div style={{ flex: 1 }}>
                  <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>TOTAL PRESTO SALES</div>
                  <div style={{ color: T.teal, fontWeight: 800, fontFamily: "monospace" }}>{fmt(prestoEntries.reduce((a, e) => a + e.amount, 0))}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>TOTAL COMMISSION</div>
                  <div style={{ color: T.red, fontWeight: 800, fontFamily: "monospace" }}>{fmt(prestoEntries.reduce((a, e) => a + e.amount * e.commission / 100, 0))}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>TOTAL NET DUE</div>
                  <div style={{ color: T.green, fontWeight: 800, fontFamily: "monospace" }}>{fmt(prestoEntries.reduce((a, e) => a + e.amount * (1 - e.commission / 100), 0))}</div>
                </div>
              </div>
            </div>
          )}

          {savedPrestoEntries.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <div style={{ color: T.muted, fontSize: 12, fontWeight: 700 }}>ALREADY SAVED FOR {date}:</div>
              {savedPrestoEntries.map((entry, i) => (
                <div key={i} style={{ background: T.surface, borderRadius: 8, padding: "8px 12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontFamily: "monospace", color: T.teal, fontWeight: 700 }}>{fmt(entry.amount)}</span>
                  <span style={{ color: T.muted, fontSize: 12 }}>@ {entry.commission}% commission</span>
                  <span style={{ color: T.red, fontSize: 12, fontFamily: "monospace" }}>-{fmt(entry.amount * entry.commission / 100)}</span>
                  <span style={{ color: T.green, fontFamily: "monospace", fontWeight: 700 }}>{fmt(entry.amount * (1 - entry.commission / 100))}</span>
                </div>
              ))}
              <div style={{ color: T.green, fontSize: 12, fontWeight: 700, textAlign: "right" }}>
                Total saved: {fmt(savedPrestoEntries.reduce((a, e) => a + e.amount, 0))} | Commission: {fmt(savedPrestoEntries.reduce((a, e) => a + e.amount * e.commission / 100, 0))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── STICKY JUMP BAR ─────────────────────────────────────────────────── */}
      {channel === "store" && (
      <div style={{
        position: "sticky", top: 58, zIndex: 100,
        background: T.surface + "EE", backdropFilter: "blur(8px)",
        borderBottom: `1px solid ${T.border}`, borderRadius: "0 0 12px 12px",
        padding: "10px 0", margin: "0 -16px",
      }}>
        <div style={{ display: "flex", gap: 6, overflowX: "auto", padding: "0 16px", scrollbarWidth: "none" }}>
          {MENU_CATEGORIES.map((cat) => {
            const count = cat.items.filter((i) => items[i.id] > 0).length;
            const isActive = activeJump === cat.id;
            return (
              <button key={cat.id} onClick={() => jumpTo(cat.id)} style={{
                background: isActive ? T.accent : T.card,
                color: isActive ? T.white : T.muted,
                border: `1px solid ${isActive ? T.accent : T.border}`,
                borderRadius: 20, padding: "6px 14px", cursor: "pointer",
                fontWeight: 600, fontSize: 12, whiteSpace: "nowrap", fontFamily: "inherit",
                flexShrink: 0,
                boxShadow: isActive ? `0 0 12px ${T.accent}55` : "none",
              }}>
                {cat.emoji} {cat.name}
                {count > 0 && (
                  <span style={{ marginLeft: 6, background: T.green, color: "#000", borderRadius: 99, padding: "1px 6px", fontSize: 10, fontWeight: 800 }}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
      )}

      {channel === "store" && menuCategories.map((cat) => (
        <div key={cat.id} ref={(el) => (sectionRefs.current[cat.id] = el)} data-catid={cat.id}
          style={{ scrollMarginTop: 110 }}>
          {/* Category header */}
          <div style={{
            display: "flex", alignItems: "center", gap: 10, marginBottom: 12,
            padding: "10px 14px", background: T.surface, borderRadius: 12,
            border: `1px solid ${T.border}`,
          }}>
            <span style={{ fontSize: 20 }}>{cat.emoji}</span>
            <div>
              <div style={{ fontWeight: 800, fontSize: 14 }}>{cat.name}</div>
              <div style={{ color: T.muted, fontSize: 11 }}>{cat.nameAr}</div>
            </div>
            {cat.items.filter((i) => items[i.id] > 0).length > 0 && (
              <Badge color={T.green} small>
                {cat.items.filter((i) => items[i.id] > 0).length} selected
              </Badge>
            )}
          </div>

          {/* Items grid */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(155px, 1fr))", gap: 10 }}>
            {cat.items.map((item) => {
              const qty = items[item.id] || 0;
              return (
                <div key={item.id} style={{
                  background: qty > 0 ? T.accent + "18" : T.card,
                  border: `1.5px solid ${qty > 0 ? T.accent : T.border}`,
                  borderRadius: 14, padding: 14, transition: "all 0.15s",
                  boxShadow: qty > 0 ? `0 0 16px ${T.accent}22` : "none",
                }}>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 1 }}>{item.name}</div>
                  <div style={{ color: T.muted, fontSize: 11, marginBottom: 10 }}>{item.nameAr}</div>
                  <div style={{ color: T.accentLight, fontWeight: 800, fontFamily: "monospace", fontSize: 14, marginBottom: 12 }}>{item.price} LYD</div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
                    <button onClick={() => setQty(item.id, qty - 1)}
                      style={{ background: T.surface, border: `1px solid ${T.border}`, color: T.text, borderRadius: 8, width: 28, height: 32, cursor: "pointer", fontSize: 16, fontFamily: "inherit", flexShrink: 0 }}>−</button>
                    <input
                      type="number" min="0" value={qty || ""}
                      placeholder="0"
                      onChange={(e) => setQty(item.id, Math.max(0, parseInt(e.target.value) || 0))}
                      style={{ background: T.surface, border: `1px solid ${qty > 0 ? T.accent : T.border}`, borderRadius: 8, color: qty > 0 ? T.accent : T.muted, fontWeight: 800, fontSize: 15, fontFamily: "monospace", width: "100%", textAlign: "center", padding: "4px 2px", outline: "none", boxSizing: "border-box" }}
                    />
                    <button onClick={() => setQty(item.id, qty + 1)}
                      style={{ background: qty > 0 ? T.accent : T.surface, border: `1px solid ${qty > 0 ? T.accent : T.border}`, color: qty > 0 ? T.white : T.text, borderRadius: 8, width: 28, height: 32, cursor: "pointer", fontSize: 16, fontFamily: "inherit", flexShrink: 0 }}>+</button>
                  </div>
                  {qty > 0 && <div style={{ textAlign: "center", color: T.green, fontSize: 11, fontWeight: 700, marginTop: 6 }}>= {(qty * item.price).toFixed(2)} LYD</div>}
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* Floating Save Bar */}
      {totals.grandTotal > 0 && role === "admin" && (
        <div style={{
          position: "fixed", bottom: 80, right: 20,
          background: T.surface, border: `1px solid ${T.border}`,
          borderRadius: 16, padding: "12px 20px", zIndex: 300,
          display: "flex", alignItems: "center", gap: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          backdropFilter: "blur(8px)",
        }}>
          <div>
            <div style={{ color: T.muted, fontSize: 11, fontWeight: 700 }}>GRAND TOTAL</div>
            <div style={{ color: T.green, fontWeight: 800, fontFamily: "monospace", fontSize: 18 }}>{fmt(totals.grandTotal)}</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {salesRecords[date] && (
              <Btn onClick={deleteSales} variant="danger" small>Delete</Btn>
            )}
            <Btn onClick={save} small>Save Sales ✅</Btn>
          </div>
        </div>
      )}

      {/* Receipt Summary */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 18, marginTop: 8 }}>
        <div style={{ fontWeight: 700, marginBottom: 14, fontSize: 15 }}>📋 Receipt Summary — {date}</div>
        {totals.savedTotal > 0 && (
          <div style={{ background: T.surface, borderRadius: 10, padding: "10px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ color: T.muted, fontSize: 12 }}>Already saved for {date}:</span>
            <span style={{ color: T.green, fontWeight: 800, fontFamily: "monospace" }}>{fmt(totals.savedTotal)}</span>
          </div>
        )}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
          {[
            { label: "Store Sales",        value: totals.storeTotal || totals.savedStore,   color: T.accent },
            { label: "Presto Sales",       value: totals.prestoTotal || savedPrestoEntries.reduce((a, e) => a + e.amount, 0),  color: T.teal },
            { label: "Presto Commission",  value: totals.prestoCommAmt || savedPrestoEntries.reduce((a, e) => a + e.amount * e.commission / 100, 0), color: T.red },
            { label: "Grand Total",        value: totals.grandTotal || totals.savedTotal,   color: T.accentLight },
          ].map((t) => (
            <div key={t.label} style={{ background: T.surface, borderRadius: 10, padding: "10px 14px", flex: 1, minWidth: 120, border: `1px solid ${T.border}` }}>
              <div style={{ color: T.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{t.label}</div>
              <div style={{ color: t.color, fontWeight: 800, fontFamily: "monospace", fontSize: 14 }}>{fmt(t.value)}</div>
            </div>
          ))}
        </div>
        <div style={{ marginBottom: 14 }}>
          <Input label="Note (optional)" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Any notes about today's sales..." />
        </div>
        {role === "admin" && (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {salesRecords[date]?.storeItems && Object.keys(salesRecords[date].storeItems).length > 0 && (
              <Btn onClick={() => {
                setSalesRecords((prev) => ({
                  ...prev, [date]: { ...prev[date], storeItems: {} }
                }));
                showToast("Store sales deleted!", "success");
              }} variant="danger" small>🗑 Store Sales</Btn>
            )}
            {salesRecords[date]?.prestoEntries?.length > 0 && (
              <Btn onClick={() => {
                setSalesRecords((prev) => ({
                  ...prev, [date]: { ...prev[date], prestoEntries: [] }
                }));
                showToast("Presto sales deleted!", "success");
              }} variant="danger" small>🗑 Presto Sales</Btn>
            )}
            {salesRecords[date] && (
              <Btn onClick={deleteSales} variant="danger" small>🗑 All Sales</Btn>
            )}
            <Btn onClick={save} full>Save Sales Record</Btn>
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// PROCUREMENT
// ═══════════════════════════════════════════════════════════════════════════════
function ProcurementEntry({ procRecords, setProcRecords, showToast, role, procurementCategories }) {
  const [date, setDate] = useState(today());
  const [entries, setEntries] = useState({});
  const [activeCategory, setActiveCategory] = useState((procurementCategories || PROCUREMENT_CATEGORIES)[0].id);

  useEffect(() => {
    setEntries({});
  }, [date]);

  const setEntry = (id, field, val) =>
    setEntries((prev) => ({ ...prev, [id]: { ...prev[id], [field]: val } }));

  const totalCost = useMemo(() =>
    Object.values(entries).reduce((a, e) => a + ((Number(e?.cost) || 0) * (Number(e?.qty) || 0)), 0), [entries]);

  const save = () => {
    const items = [];
    (procurementCategories || PROCUREMENT_CATEGORIES).forEach((cat) => {
      cat.items.forEach((item) => {
        const e = entries[item.id];
        if (e?.qty || e?.cost) items.push({
          id: item.id, name: item.name, nameAr: item.nameAr,
          categoryId: cat.id, categoryName: cat.name, unit: cat.unit,
          qty: Number(e.qty) || 0, cost: Number(e.cost) || 0, totalCost: (Number(e.qty) || 0) * (Number(e.cost) || 0),
        });
      });
    });
    if (items.length === 0) { showToast("Please enter at least one item", "error"); return; }
    setProcRecords((prev) => {
      const existing = prev[date];
      if (existing) {
        const mergedItems = [...existing.items];
        items.forEach((newItem) => {
          const existingIdx = mergedItems.findIndex((e) => e.id === newItem.id);
          if (existingIdx >= 0) {
            mergedItems[existingIdx] = {
              ...mergedItems[existingIdx],
              qty: mergedItems[existingIdx].qty + newItem.qty,
              totalCost: mergedItems[existingIdx].totalCost + newItem.totalCost,
            };
          } else {
            mergedItems.push(newItem);
          }
        });
        return { ...prev, [date]: { date, items: mergedItems } };
      }
      return { ...prev, [date]: { date, items } };
    });
    setEntries({});
    showToast("Procurement saved! Fields reset for next entry ✅", "success");
  };

  const deleteProcurement = () => {
    setProcRecords((prev) => {
      const next = { ...prev };
      delete next[date];
      return next;
    });
    setEntries({});
    showToast("Procurement record deleted!", "success");
  };

  const activeCat = (procurementCategories || PROCUREMENT_CATEGORIES).find((c) => c.id === activeCategory);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Record Procurement</div>
          <div style={{ color: T.muted, fontSize: 13 }}>Enter quantities and costs for today's purchases</div>
        </div>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
          style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
      </div>

      <div style={{ display: "flex", gap: 8 }}>
        {(procurementCategories || PROCUREMENT_CATEGORIES).map((cat) => {
          const count = cat.items.filter((i) => entries[i.id]?.qty || entries[i.id]?.cost).length;
          return (
            <button key={cat.id} onClick={() => setActiveCategory(cat.id)} style={{
              background: activeCategory === cat.id ? T.yellow : T.card,
              color: activeCategory === cat.id ? "#000" : T.muted,
              border: `1px solid ${activeCategory === cat.id ? T.yellow : T.border}`,
              borderRadius: 10, padding: "8px 16px", cursor: "pointer",
              fontWeight: 600, fontSize: 13, fontFamily: "inherit",
              boxShadow: activeCategory === cat.id ? `0 0 14px ${T.yellow}44` : "none",
            }}>
              {cat.emoji} {cat.name}
              {count > 0 && <span style={{ marginLeft: 6, background: T.green, color: "#000", borderRadius: 99, padding: "1px 7px", fontSize: 10 }}>{count}</span>}
            </button>
          );
        })}
      </div>

      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>{activeCat?.emoji} {activeCat?.name}</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 110px 120px", gap: "8px 12px", alignItems: "center" }}>
          <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Item</div>
          <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Qty ({activeCat?.unit})</div>
          <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Price/Unit (LYD)</div>
          {activeCat?.items.map((item) => {
            const e = entries[item.id] || {};
            const hasData = e.qty || e.cost;
            return [
              <div key={item.id + "_n"} className="proc-item" style={{ fontWeight: 600, fontSize: 13, color: hasData ? T.text : T.muted, padding: "4px 8px", borderRadius: 6, transition: "background 0.15s", cursor: "default" }}>
                {item.name} <span style={{ color: T.muted, fontWeight: 400 }}>({item.nameAr})</span>
              </div>,
              <input key={item.id + "_q"} type="number" placeholder="0" value={e.qty || ""} min="0" step="0.1"
                onChange={(v) => setEntry(item.id, "qty", v.target.value)}
                style={{ background: T.surface, border: `1px solid ${hasData ? T.yellow : T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 13, fontFamily: "inherit", width: "100%", boxSizing: "border-box" }} />,
              <input key={item.id + "_c"} type="number" placeholder="0" value={e.cost || ""} min="0"
                onChange={(v) => setEntry(item.id, "cost", v.target.value)}
                style={{ background: T.surface, border: `1px solid ${hasData ? T.yellow : T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 13, fontFamily: "inherit", width: "100%", boxSizing: "border-box" }} />,
            ];
          })}
        </div>
      </div>

      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ color: T.muted, fontSize: 12 }}>Total Procurement Cost for {date}</div>
          <div style={{ color: T.yellow, fontWeight: 800, fontFamily: "monospace", fontSize: 20 }}>
            {fmt(procRecords[date] ? procRecords[date].items?.reduce((a, i) => a + (Number(i.totalCost) || (Number(i.cost) * Number(i.qty)) || 0), 0) : totalCost)}
          </div>
          {totalCost > 0 && (
            <div style={{ color: T.green, fontSize: 12, marginTop: 4 }}>
              This entry: {fmt(totalCost)}
            </div>
          )}
        </div>
        {role === "admin" && (
          <div style={{ display: "flex", gap: 8 }}>
            {procRecords[date] && (
              <Btn onClick={deleteProcurement} variant="danger">Delete Record</Btn>
            )}
            <Btn onClick={save} color={T.yellow}>Save Procurement</Btn>
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// WAGES & STAFF
// ═══════════════════════════════════════════════════════════════════════════════
function WagesStaff({ staff, setStaff, wageRecords, setWageRecords, showToast, role }) {
  const [tab, setTab] = useState("wages");
  const [date, setDate] = useState(today());
  const [attendance, setAttendance] = useState({});
  const [loanModal, setLoanModal] = useState(null);
  const [loanAmt, setLoanAmt] = useState("");
  const [loanNote, setLoanNote] = useState("");
  const [addStaffModal, setAddStaffModal] = useState(false);
  const [newStaff, setNewStaff] = useState({ name: "", nameAr: "", type: "daily", dailyRate: "", monthlyRate: "", role: "" });

  useEffect(() => {
    const rec = wageRecords[date];
    if (rec) {
      const att = {};
      rec.wages?.forEach((w) => { att[w.staffId] = { present: w.present, amount: w.amount }; });
      setAttendance(att);
    } else {
      const att = {};
      staff.filter((s) => s.type === "daily").forEach((s) => { att[s.id] = { present: true, amount: s.dailyRate }; });
      setAttendance(att);
    }
  }, [date, staff]);

  const dailyStaff = staff.filter((s) => s.type === "daily");
  const monthlyStaff = staff.filter((s) => s.type === "monthly");
  const totalWages = dailyStaff.reduce((a, s) => a + (attendance[s.id]?.present ? Number(attendance[s.id]?.amount || s.dailyRate) : 0), 0);

  const saveWages = () => {
    const wages = dailyStaff.map((s) => ({
      staffId: s.id, name: s.name,
      amount: Number(attendance[s.id]?.amount || s.dailyRate),
      present: attendance[s.id]?.present ?? true,
    }));
    setWageRecords((prev) => ({ ...prev, [date]: { date, wages } }));
    showToast("Daily wages saved! ✅", "success");
  };

  const deleteWages = () => {
    setWageRecords((prev) => {
      const next = { ...prev };
      delete next[date];
      return next;
    });
    setAttendance({});
    showToast("Wages record deleted!", "success");
  };

  const addLoan = (staffId) => {
    if (!loanAmt) return;
    setStaff((prev) => prev.map((s) => s.id === staffId ? {
      ...s, loans: [...(s.loans || []), { id: genId(), amount: Number(loanAmt), repaid: 0, date: today(), note: loanNote }]
    } : s));
    setLoanModal(null); setLoanAmt(""); setLoanNote("");
    showToast("Loan recorded! ✅", "success");
  };

  const repayLoan = (staffId, loanId, amount) => {
    setStaff((prev) => prev.map((s) => s.id === staffId ? {
      ...s, loans: s.loans.map((l) => l.id === loanId ? { ...l, repaid: Math.min(l.amount, (l.repaid || 0) + Number(amount)) } : l)
    } : s));
    showToast("Repayment recorded!", "success");
  };

  const addNewStaff = () => {
    if (!newStaff.name) return;
    setStaff((prev) => [...prev, { ...newStaff, id: genId(), dailyRate: Number(newStaff.dailyRate), monthlyRate: Number(newStaff.monthlyRate), loans: [] }]);
    setAddStaffModal(false);
    setNewStaff({ name: "", nameAr: "", type: "daily", dailyRate: "", monthlyRate: "", role: "" });
    showToast("Staff added! ✅", "success");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>Wages & Staff</div>
        <div style={{ display: "flex", gap: 8 }}>
          {[["wages","📅 Daily Wages"],["staff","👥 Staff"]].map(([t, l]) => (
            <Pill key={t} label={l} active={tab === t} onClick={() => setTab(t)} />
          ))}
        </div>
      </div>

      {tab === "wages" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
              style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
          </div>
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>👷 Daily Wage Staff</div>
            {dailyStaff.map((s) => {
              const att = attendance[s.id] || { present: true, amount: s.dailyRate };
              return (
                <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: `1px solid ${T.border}30` }}>
                  <div onClick={() => setAttendance((prev) => ({ ...prev, [s.id]: { ...att, present: !att.present } }))}
                    style={{ width: 44, height: 24, borderRadius: 12, background: att.present ? T.green : T.border, cursor: "pointer", position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
                    <div style={{ position: "absolute", width: 18, height: 18, background: "#fff", borderRadius: 9, top: 3, left: att.present ? 22 : 3, transition: "left 0.2s" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700 }}>{s.name}</div>
                    <div style={{ color: T.muted, fontSize: 12 }}>{s.role}</div>
                  </div>
                  <input type="number" value={att.amount ?? s.dailyRate}
                    onChange={(e) => setAttendance((prev) => ({ ...prev, [s.id]: { ...att, amount: e.target.value } }))}
                    disabled={!att.present}
                    style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: att.present ? T.text : T.muted, padding: "7px 10px", fontSize: 14, fontFamily: "monospace", width: 90, textAlign: "right", opacity: att.present ? 1 : 0.4 }} />
                  <span style={{ color: T.muted, fontSize: 13 }}>LYD</span>
                  <Badge color={att.present ? T.green : T.muted}>{att.present ? "Present" : "Absent"}</Badge>
                </div>
              );
            })}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
              <div>
                <div style={{ color: T.muted, fontSize: 12 }}>Total Wages for {date}</div>
                <div style={{ color: T.teal, fontWeight: 800, fontFamily: "monospace", fontSize: 20 }}>{fmt(totalWages)}</div>
              </div>
              {role === "admin" && (
                <div style={{ display: "flex", gap: 8 }}>
                  {wageRecords[date] && (
                    <Btn onClick={deleteWages} variant="danger">Delete Record</Btn>
                  )}
                  <Btn onClick={saveWages} color={T.teal}>Save Wages</Btn>
                </div>
              )}
            </div>
          </div>
          
        </div>
      )}

      {tab === "staff" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {role === "admin" && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Btn onClick={() => setAddStaffModal(true)}>+ Add Staff</Btn>
            </div>
          )}
          {staff.map((s) => (
            <div key={s.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 18, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontWeight: 700 }}>{s.name} <span style={{ color: T.muted, fontWeight: 400 }}>({s.nameAr})</span></div>
                <div style={{ color: T.muted, fontSize: 12, marginTop: 2 }}>{s.role}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <Badge color={s.type === "daily" ? T.teal : T.purple}>{s.type === "daily" ? "Daily" : "Monthly"}</Badge>
                <div style={{ color: T.accent, fontWeight: 800, fontFamily: "monospace", marginTop: 6 }}>
                  {s.type === "daily" ? `${s.dailyRate} LYD/day` : `${s.monthlyRate} LYD/mo`}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      

      {loanModal && (
        <Modal title={`Loan for ${loanModal.name}`} onClose={() => { setLoanModal(null); setLoanAmt(""); setLoanNote(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Select label="Staff Member" value={loanModal.id} onChange={(e) => setLoanModal(staff.find((s) => s.id === e.target.value))}>
              {staff.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </Select>
            <Input label="Loan Amount (LYD)" type="number" placeholder="0" value={loanAmt} onChange={(e) => setLoanAmt(e.target.value)} />
            <Input label="Note (optional)" placeholder="Reason..." value={loanNote} onChange={(e) => setLoanNote(e.target.value)} />
            <Btn onClick={() => addLoan(loanModal.id)} full>Record Loan</Btn>
          </div>
        </Modal>
      )}

      {addStaffModal && (
        <Modal title="Add New Staff Member" onClose={() => setAddStaffModal(false)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Name (English)" value={newStaff.name} onChange={(e) => setNewStaff((p) => ({ ...p, name: e.target.value }))} placeholder="e.g. Ahmed" />
            <Input label="Name (Arabic)" value={newStaff.nameAr} onChange={(e) => setNewStaff((p) => ({ ...p, nameAr: e.target.value }))} placeholder="e.g. أحمد" />
            <Input label="Role" value={newStaff.role} onChange={(e) => setNewStaff((p) => ({ ...p, role: e.target.value }))} placeholder="Kitchen, Cashier..." />
            <Select label="Wage Type" value={newStaff.type} onChange={(e) => setNewStaff((p) => ({ ...p, type: e.target.value }))}>
              <option value="daily">Daily Wages</option>
              <option value="monthly">Monthly Salary</option>
            </Select>
            {newStaff.type === "daily"
              ? <Input label="Daily Rate (LYD)" type="number" value={newStaff.dailyRate} onChange={(e) => setNewStaff((p) => ({ ...p, dailyRate: e.target.value }))} />
              : <Input label="Monthly Salary (LYD)" type="number" value={newStaff.monthlyRate} onChange={(e) => setNewStaff((p) => ({ ...p, monthlyRate: e.target.value }))} />
            }
            <Btn onClick={addNewStaff} full>Add Staff Member</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MONTHLY EXPENSES
// ═══════════════════════════════════════════════════════════════════════════════
function MonthlyExpenses({ monthlyExpenses, setMonthlyExpenses, staff, setStaff, showToast, role }) {
  const [month, setMonth] = useState(monthKey());
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ category: "Rent", description: "", amount: "" });
  const [payModal, setPayModal] = useState(null);
  const [payAmount, setPayAmount] = useState("");
  const [editPayModal, setEditPayModal] = useState(null);
  const [editPayAmount, setEditPayAmount] = useState("");
  const CATS = ["Electricity", "Water", "Gas", "Internet", "Maintenance", "Other"];

  const filtered = monthlyExpenses.filter((e) => e.yearMonth === month && e.category !== "Salary" && !e.rentId);
  const total = filtered.reduce((a, e) => a + Number(e.amount), 0);
  const monthlySalaryTotal = staff.filter((s) => s.type === "monthly").reduce((a, s) => a + s.monthlyRate, 0);
  const totalRents = MONTHLY_RENTS.reduce((a, r) => a + r.amount, 0);

  const save = () => {
    if (!form.amount) return;
    setMonthlyExpenses((prev) => [...prev, { ...form, id: genId(), yearMonth: month, amount: Number(form.amount), paid: false }]);
    setModal(false);
    setForm({ category: "Electricity", description: "", amount: "" });
    showToast("Expense added! ✅", "success");
  };

  const openPayModal = (s) => {
    const loanDeduct = s.loans?.reduce((a, l) => a + (l.amount - (l.repaid || 0)), 0) || 0;
    setPayModal(s);
    setPayAmount((s.monthlyRate - loanDeduct).toString());
  };

  const confirmPay = () => {
    if (!payModal || !payAmount) return;
    const payment = {
      id: genId(), category: "Salary",
      description: `Salary — ${payModal.name}`,
      amount: Number(payAmount), yearMonth: month,
      paid: true, staffId: payModal.id,
      staffName: payModal.name, paidDate: today(),
    };
    setMonthlyExpenses((prev) => [...prev.filter((e) => !(e.staffId === payModal.id && e.yearMonth === month)), payment]);
    setPayModal(null); setPayAmount("");
    showToast(`${payModal.name} salary paid! ✅`, "success");
  };

  const openEditPay = (payment) => {
    setEditPayModal(payment);
    setEditPayAmount(payment.amount.toString());
  };

  const confirmEditPay = () => {
    if (!editPayModal || !editPayAmount) return;
    setMonthlyExpenses((prev) => prev.map((e) => e.id === editPayModal.id ? { ...e, amount: Number(editPayAmount) } : e));
    setEditPayModal(null); setEditPayAmount("");
    showToast("Payment updated! ✅", "success");
  };

  const deleteSalaryPayment = (staffId) => {
    setMonthlyExpenses((prev) => prev.filter((e) => !(e.staffId === staffId && e.yearMonth === month && e.category === "Salary")));
    showToast("Salary payment deleted!", "success");
  };

  const [loanModal, setLoanModal] = useState(null);
  const [loanAmt, setLoanAmt] = useState("");
  const [loanNote, setLoanNote] = useState("");

  const addLoan = (staffId) => {
    if (!loanAmt) return;
    setStaff((prev) => prev.map((s) => s.id === staffId ? {
      ...s, loans: [...(s.loans || []), { id: genId(), amount: Number(loanAmt), repaid: 0, date: today(), note: loanNote }]
    } : s));
    setLoanModal(null); setLoanAmt(""); setLoanNote("");
    showToast("Loan recorded! ✅", "success");
  };

  const payRent = (r) => {
    const payment = {
      id: genId(), category: "Rent",
      description: r.name, amount: r.amount,
      yearMonth: month, paid: true,
      rentId: r.id, paidDate: today(),
    };
    setMonthlyExpenses((prev) => [...prev, payment]);
    showToast(`${r.name} paid! ✅`, "success");
  };

  const deleteRentPayment = (rentId) => {
    setMonthlyExpenses((prev) => prev.filter((e) => !(e.rentId === rentId && e.yearMonth === month)));
    showToast("Rent payment deleted!", "success");
  };

  const grandTotal = monthlySalaryTotal + totalRents + total;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>Monthly Expenses</div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <input type="month" value={month} onChange={(e) => setMonth(e.target.value)}
            style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
          {role === "admin" && <Btn onClick={() => setModal(true)}>+ Add Expense</Btn>}
        </div>
      </div>

      {/* Monthly Salaries */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>💼 Monthly Salaries (Fixed)</div>
        {staff.filter((s) => s.type === "monthly").map((s) => {
          const loanDeduct = s.loans?.reduce((a, l) => a + (l.amount - (l.repaid || 0)), 0) || 0;
          const netAmount = s.monthlyRate - loanDeduct;
          const alreadyPaid = monthlyExpenses.find((e) => e.staffId === s.id && e.yearMonth === month && e.category === "Salary");
          return (
            <div key={s.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${T.border}30` }}>
              <div>
                <div style={{ fontWeight: 600 }}>{s.name}</div>
                <div style={{ color: T.muted, fontSize: 12 }}>{s.role}</div>
                {alreadyPaid && <div style={{ color: T.green, fontSize: 11, marginTop: 2 }}>✅ Paid on {alreadyPaid.paidDate} — {fmt(alreadyPaid.amount)}</div>}
              </div>
              <div style={{ textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                <div style={{ fontFamily: "monospace", fontWeight: 700, color: T.accent }}>{fmt(s.monthlyRate)}</div>
                {loanDeduct > 0 && <div style={{ color: T.red, fontSize: 12 }}>Loan: -{fmt(loanDeduct)}</div>}
                {loanDeduct > 0 && <div style={{ color: T.green, fontSize: 12, fontWeight: 700 }}>Net: {fmt(netAmount)}</div>}
                <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>
                  {alreadyPaid ? (
                    <>
                      <Badge color={T.green}>Paid ✓</Badge>
                      {role === "admin" && <>
                        <button onClick={() => openEditPay(alreadyPaid)} style={{ background: T.card, border: `1px solid ${T.border}`, color: T.text, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>✏️ Edit</button>
                        <button onClick={() => deleteSalaryPayment(s.id)} style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑 Delete</button>
                      </>}
                    </>
                  ) : role === "admin" ? (
                    <Btn small onClick={() => openPayModal(s)} color={T.green}>Pay Now</Btn>
                  ) : null}
                  {role === "admin" && <Btn small variant="ghost" onClick={() => setLoanModal(s)}>+ Loan</Btn>}
                </div>
              </div>
            </div>
          );
        })}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, paddingTop: 12, borderTop: `1px solid ${T.border}` }}>
          <span style={{ fontWeight: 700 }}>Total Monthly Salaries</span>
          <span style={{ fontWeight: 800, fontFamily: "monospace", color: T.accent }}>{fmt(monthlySalaryTotal)}</span>
        </div>
      </div>

      {/* Monthly Rents */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>🏠 Monthly Rents (Fixed)</div>
        {MONTHLY_RENTS.map((r) => {
          const rentPaid = monthlyExpenses.find((e) => e.rentId === r.id && e.yearMonth === month);
          return (
            <div key={r.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${T.border}30` }}>
              <div>
                <div style={{ fontWeight: 600 }}>{r.name}</div>
                {rentPaid && <div style={{ color: T.green, fontSize: 11, marginTop: 2 }}>✅ Paid on {rentPaid.paidDate} — {fmt(rentPaid.amount)}</div>}
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                <div style={{ fontFamily: "monospace", fontWeight: 700, color: T.accent }}>{fmt(r.amount)}</div>
                {rentPaid ? (
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <Badge color={T.green}>Paid ✓</Badge>
                    {role === "admin" && <>
                      <button onClick={() => openEditPay(rentPaid)} style={{ background: T.card, border: `1px solid ${T.border}`, color: T.text, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>✏️ Edit</button>
                      <button onClick={() => deleteRentPayment(r.id)} style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑 Delete</button>
                    </>}
                  </div>
                ) : role === "admin" ? (
                  <button onClick={() => payRent(r)} style={{ background: T.green, border: "none", color: "#000", borderRadius: 8, padding: "6px 14px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 700 }}>Pay Now</button>
                ) : null}
              </div>
            </div>
          );
        })}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, paddingTop: 12, borderTop: `1px solid ${T.border}` }}>
          <span style={{ fontWeight: 700 }}>Total Monthly Rents</span>
          <span style={{ fontWeight: 800, fontFamily: "monospace", color: T.accent }}>{fmt(totalRents)}</span>
        </div>
      </div>

      {/* Fixed Monthly Expenses */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>🏢 Fixed Monthly Expenses</div>
        {filtered.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No expenses added for {month}</div>}
        {filtered.map((e) => (
          <div key={e.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: `1px solid ${T.border}30` }}>
            <div onClick={() => role === "admin" && setMonthlyExpenses((prev) => prev.map((x) => x.id === e.id ? { ...x, paid: !x.paid } : x))}
              style={{ width: 22, height: 22, borderRadius: 6, background: e.paid ? T.green : T.border, cursor: role === "admin" ? "pointer" : "default", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 13, flexShrink: 0 }}>
              {e.paid ? "✓" : ""}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>{e.category}</div>
              <div style={{ color: T.muted, fontSize: 12 }}>{e.description}</div>
            </div>
            <div style={{ fontFamily: "monospace", fontWeight: 700, color: e.paid ? T.green : T.yellow }}>{fmt(e.amount)}</div>
            <Badge color={e.paid ? T.green : T.yellow}>{e.paid ? "Paid" : "Pending"}</Badge>
            {role === "admin" && <button onClick={() => setMonthlyExpenses((prev) => prev.filter((x) => x.id !== e.id))}
              style={{ background: T.red + "22", color: T.red, border: "none", borderRadius: 8, width: 28, height: 28, cursor: "pointer", fontWeight: 700 }}>×</button>}
          </div>
        ))}
        {filtered.length > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14, paddingTop: 14, borderTop: `1px solid ${T.border}` }}>
            <span style={{ fontWeight: 700 }}>Total Fixed Expenses</span>
            <span style={{ fontWeight: 800, fontFamily: "monospace", color: T.yellow }}>{fmt(total)}</span>
          </div>
        )}
      </div>

      {/* Grand Total */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 18, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ color: T.muted, fontSize: 12 }}>Total Monthly Cost (Salaries + Rents + Fixed)</div>
          <div style={{ color: T.red, fontWeight: 800, fontFamily: "monospace", fontSize: 22 }}>{fmt(grandTotal)}</div>
        </div>
        <div style={{ color: T.muted, fontSize: 13, textAlign: "right" }}>
          <div>Salaries: {fmt(monthlySalaryTotal)}</div>
          <div>Rents: {fmt(totalRents)}</div>
          <div>Fixed: {fmt(total)}</div>
        </div>
      </div>
{/* Loans Section */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>💳 Staff Loans</div>
        {staff.filter((s) => s.loans?.some((l) => (l.repaid || 0) < l.amount)).length === 0 && (
          <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No active loans 🎉</div>
        )}
        {staff.map((s) => {
          const activeLoans = s.loans?.filter((l) => (l.repaid || 0) < l.amount) || [];
          if (!activeLoans.length) return null;
          return (
            <div key={s.id} style={{ marginBottom: 16, background: T.surface, borderRadius: 12, padding: 14 }}>
              <div style={{ fontWeight: 700, marginBottom: 10 }}>{s.name} — {s.role}</div>
              {activeLoans.map((loan) => {
                const outstanding = loan.amount - (loan.repaid || 0);
                const pct = ((loan.repaid || 0) / loan.amount) * 100;
                return (
                  <div key={loan.id} style={{ marginBottom: 12, background: T.card, borderRadius: 10, padding: 12 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                      <div>
                        <span style={{ fontWeight: 700, color: T.red }}>{fmt(loan.amount)}</span>
                        <span style={{ color: T.muted, fontSize: 12 }}> on {loan.date}</span>
                        {loan.note && <div style={{ color: T.muted, fontSize: 12 }}>{loan.note}</div>}
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ color: T.green, fontSize: 12 }}>Repaid: {fmt(loan.repaid || 0)}</div>
                        <div style={{ color: T.red, fontWeight: 700 }}>Left: {fmt(outstanding)}</div>
                      </div>
                    </div>
                    <div style={{ background: T.border, borderRadius: 99, height: 6, marginBottom: 10 }}>
                      <div style={{ background: T.green, width: `${pct}%`, height: 6, borderRadius: 99 }} />
                    </div>
                    {role === "admin" && (
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        {[50, 100, 200].map((amt) => (
                          <Btn key={amt} small variant="ghost" onClick={() => {
                            setStaff((prev) => prev.map((st) => st.id === s.id ? {
                              ...st, loans: st.loans.map((l) => l.id === loan.id ? { ...l, repaid: Math.min(l.amount, (l.repaid || 0) + Math.min(amt, outstanding)) } : l)
                            } : st));
                            showToast("Repayment recorded!", "success");
                          }}>Repay {amt}</Btn>
                        ))}
                        <button onClick={() => {
                          setStaff((prev) => prev.map((st) => st.id === s.id ? {
                            ...st, loans: st.loans.filter((l) => l.id !== loan.id)
                          } : st));
                          showToast("Loan deleted!", "success");
                        }} style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑 Delete</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* Edit Payment Modal */}
      {editPayModal && (
        <Modal title={`Edit Payment — ${editPayModal.staffName || editPayModal.description}`} onClose={() => { setEditPayModal(null); setEditPayAmount(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ background: T.card, borderRadius: 10, padding: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ color: T.muted, fontSize: 13 }}>Paid on</span>
                <span style={{ fontWeight: 700 }}>{editPayModal.paidDate}</span>
              </div>
            </div>
            <Input label="Payment Amount (LYD)" type="number" value={editPayAmount} onChange={(e) => setEditPayAmount(e.target.value)} />
            <Btn onClick={confirmEditPay} full color={T.accent}>Update Payment</Btn>
          </div>
        </Modal>
      )}

      {/* Pay Salary Modal */}
      {payModal && (
        <Modal title={`Pay Salary — ${payModal.name}`} onClose={() => { setPayModal(null); setPayAmount(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ background: T.card, borderRadius: 10, padding: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ color: T.muted, fontSize: 13 }}>Monthly Salary</span>
                <span style={{ fontFamily: "monospace", fontWeight: 700 }}>{fmt(payModal.monthlyRate)}</span>
              </div>
              {payModal.loans?.some((l) => (l.repaid || 0) < l.amount) && (
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ color: T.red, fontSize: 13 }}>Loan Deduction</span>
                  <span style={{ fontFamily: "monospace", fontWeight: 700, color: T.red }}>
                    -{fmt(payModal.loans.reduce((a, l) => a + (l.amount - (l.repaid || 0)), 0))}
                  </span>
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${T.border}`, paddingTop: 8, marginTop: 4 }}>
                <span style={{ fontWeight: 700 }}>Amount to Pay</span>
                <span style={{ fontFamily: "monospace", fontWeight: 800, color: T.green }}>{fmt(Number(payAmount))}</span>
              </div>
            </div>
            <Input label="Confirm Payment Amount (LYD)" type="number" value={payAmount} onChange={(e) => setPayAmount(e.target.value)} />
            <div style={{ color: T.muted, fontSize: 12 }}>You can adjust the amount if needed before confirming.</div>
            <Btn onClick={confirmPay} full color={T.green}>Confirm Payment</Btn>
          </div>
        </Modal>
      )}

      {/* Add Expense Modal */}
      {loanModal && (
        <Modal title={`Loan for ${loanModal.name}`} onClose={() => { setLoanModal(null); setLoanAmt(""); setLoanNote(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Select label="Staff Member" value={loanModal.id} onChange={(e) => setLoanModal(staff.find((s) => s.id === e.target.value))}>
              {staff.filter((s) => s.type === "monthly").map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </Select>
            <Input label="Loan Amount (LYD)" type="number" placeholder="0" value={loanAmt} onChange={(e) => setLoanAmt(e.target.value)} />
            <Input label="Note (optional)" placeholder="Reason..." value={loanNote} onChange={(e) => setLoanNote(e.target.value)} />
            <Btn onClick={() => addLoan(loanModal.id)} full>Record Loan</Btn>
          </div>
        </Modal>
      )}
      {modal && (
        <Modal title="Add Monthly Expense" onClose={() => setModal(false)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Select label="Category" value={form.category} onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))}>
              {CATS.map((c) => <option key={c}>{c}</option>)}
            </Select>
            <Input label="Description" value={form.description} onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} placeholder="e.g. Monthly electricity bill" />
            <Input label="Amount (LYD)" type="number" value={form.amount} onChange={(e) => setForm((p) => ({ ...p, amount: e.target.value }))} />
            <Btn onClick={save} full>Add Expense</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// HISTORY
// ═══════════════════════════════════════════════════════════════════════════════
function History({ salesRecords, procRecords, wageRecords, role, setSalesRecords, setProcRecords, setWageRecords, showToast }) {
  const allDates = useMemo(() => {
    const dates = new Set([...Object.keys(salesRecords), ...Object.keys(procRecords), ...Object.keys(wageRecords)]);
    return [...dates].sort((a, b) => b.localeCompare(a));
  }, [salesRecords, procRecords, wageRecords]);

  const [expanded, setExpanded] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ fontSize: 22, fontWeight: 800 }}>History</div>
      {allDates.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 60 }}>No records yet. Start by recording today's sales.</div>}
      {allDates.map((date) => {
        const s = salesRecords[date], p = procRecords[date], w = wageRecords[date];
        let storeRev = 0, prestoRev = 0, prestoComm = 0;
        if (s) {
          ALL_MENU_ITEMS.forEach((item) => {
            storeRev += (s.storeItems?.[item.id] || 0) * item.price;
          });
          (s.prestoEntries || []).forEach((e) => {
            prestoRev += e.amount;
            prestoComm += e.amount * e.commission / 100;
          });
        }
        const totalRev = storeRev;
        const procCost = p?.items?.reduce((a, i) => a + (Number(i.qty) * Number(i.cost)), 0) || 0;
        const wagesCost = w?.wages?.filter((wg) => wg.present).reduce((a, wg) => a + Number(wg.amount), 0) || 0;
        const netProfit = totalRev - procCost - wagesCost - prestoComm;
        const isOpen = expanded === date;
        return (
          <div key={date} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden" }}>
            <div style={{ padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div onClick={() => setExpanded(isOpen ? null : date)} style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", cursor: "pointer", flex: 1 }}>
                <span style={{ fontWeight: 700 }}>{new Date(date + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</span>
                {s && <Badge color={T.accent} small>Sales ✓</Badge>}
                {p && <Badge color={T.yellow} small>Procurement ✓</Badge>}
                {w && <Badge color={T.teal} small>Wages ✓</Badge>}
              </div>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <span style={{ fontFamily: "monospace", fontWeight: 800, color: netProfit >= 0 ? T.green : T.red }}>{fmt(netProfit)}</span>
                {role === "admin" && (
                  <button onClick={(e) => {
                    e.stopPropagation();
                    setDeleteConfirm(date);
                  }} style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑 Delete Day</button>
                )}
                <span onClick={() => setExpanded(isOpen ? null : date)} style={{ color: T.muted, cursor: "pointer" }}>{isOpen ? "▲" : "▼"}</span>
              </div>
            </div>
            {isOpen && (
              <div style={{ borderTop: `1px solid ${T.border}`, padding: 18, display: "flex", gap: 14, flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: 160 }}>
                  <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>Revenue</div>
                  <div style={{ fontSize: 13 }}>🏪 Store Sales: <span style={{ color: T.accent, fontWeight: 700 }}>{fmt(storeRev)}</span></div>
                  <div style={{ fontSize: 13 }}>🛵 Presto Sales: <span style={{ color: T.teal, fontWeight: 700 }}>{fmt(prestoRev)}</span></div>
                  <div style={{ fontSize: 13 }}>✂️ Presto Commission: <span style={{ color: T.red, fontWeight: 700 }}>-{fmt(prestoComm)}</span></div>
                  <div style={{ fontSize: 13, fontWeight: 700 }}>Total: <span style={{ color: T.accentLight }}>{fmt(totalRev)}</span></div>
                </div>
                <div style={{ flex: 1, minWidth: 160 }}>
                  <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>Expenses</div>
                  <div style={{ fontSize: 13 }}>📦 Procurement: <span style={{ color: T.yellow, fontWeight: 700 }}>{fmt(procCost)}</span></div>
                  <div style={{ fontSize: 13 }}>👷 Wages: <span style={{ color: T.teal, fontWeight: 700 }}>{fmt(wagesCost)}</span></div>
                </div>
                <div style={{ flex: 1, minWidth: 160 }}>
                  <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>P&L</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: netProfit >= 0 ? T.green : T.red }}>{fmt(netProfit)}</div>
                  <Badge color={netProfit >= 0 ? T.green : T.red}>{netProfit >= 0 ? "Profitable Day" : "Loss Day"}</Badge>
                </div>
              </div>
            )}
          </div>
        );
      })}

      {deleteConfirm && (
        <Modal title="Delete Day Records" onClose={() => setDeleteConfirm(null)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ background: T.card, borderRadius: 12, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🗑</div>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Delete all records for</div>
              <div style={{ color: T.accent, fontWeight: 800, fontSize: 18 }}>
                {new Date(deleteConfirm + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
              </div>
              <div style={{ color: T.muted, fontSize: 12, marginTop: 8 }}>This will delete Sales, Procurement and Wages for this day. This cannot be undone.</div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <Btn full variant="ghost" onClick={() => setDeleteConfirm(null)}>Cancel</Btn>
              <Btn full variant="danger" onClick={() => {
                setSalesRecords((prev) => { const n = { ...prev }; delete n[deleteConfirm]; return n; });
                setProcRecords((prev) => { const n = { ...prev }; delete n[deleteConfirm]; return n; });
                setWageRecords((prev) => { const n = { ...prev }; delete n[deleteConfirm]; return n; });
                setDeleteConfirm(null);
                showToast("Day deleted! ✅", "success");
              }}>Yes, Delete</Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// PRESTO
// ═══════════════════════════════════════════════════════════════════════════════
function Presto({ salesRecords, menuCategories, prestoPayments, setPrestoPayments, showToast, role }) {
  const [fromDate, setFromDate] = useState(`${monthKey()}-01`);
  const [toDate, setToDate] = useState(today());
  const [addPaymentModal, setAddPaymentModal] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState(today());
  const [paymentNote, setPaymentNote] = useState("");

  const allMenuItems = useMemo(() => menuCategories.flatMap((c) => c.items), [menuCategories]);

  const stats = useMemo(() => {
    const filtered = Object.values(salesRecords).filter((r) => r.date >= fromDate && r.date <= toDate);
    let prestoGross = 0, prestoComm = 0;
    filtered.forEach((r) => {
      (r.prestoEntries || []).forEach((e) => {
        prestoGross += e.amount;
        prestoComm += e.amount * e.commission / 100;
      });
    });
    const prestoNet = prestoGross - prestoComm;
    const totalReceived = prestoPayments
      .filter((p) => p.date >= fromDate && p.date <= toDate)
      .reduce((a, p) => a + Number(p.amount), 0);
    const outstanding = prestoNet - totalReceived;

    // Daily breakdown
    const daily = filtered.map((r) => {
      let gross = 0, comm = 0;
      allMenuItems.forEach((item) => {
        const g = (r.prestoItems?.[item.id] || 0) * item.price;
        gross += g;
        comm += g * ((r.prestoCommission || 20) / 100);
      });
      return { date: r.date, gross, comm, net: gross - comm };
    }).filter((d) => d.gross > 0);

    return { prestoGross, prestoComm, prestoNet, totalReceived, outstanding, daily };
  }, [salesRecords, prestoPayments, fromDate, toDate, allMenuItems]);

  const addPayment = () => {
    if (!paymentAmount) return;
    setPrestoPayments((prev) => [...prev, {
      id: genId(),
      amount: Number(paymentAmount),
      date: paymentDate,
      note: paymentNote,
    }]);
    setAddPaymentModal(false);
    setPaymentAmount(""); setPaymentDate(today()); setPaymentNote("");
    showToast("Payment recorded! ✅", "success");
  };

  const deletePayment = (id) => {
    setPrestoPayments((prev) => prev.filter((p) => p.id !== id));
    showToast("Payment deleted!", "success");
  };

  const filteredPayments = prestoPayments
    .filter((p) => p.date >= fromDate && p.date <= toDate)
    .sort((a, b) => b.date.localeCompare(a.date));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>🛵 Presto Account</div>
        {role === "admin" && <Btn onClick={() => setAddPaymentModal(true)} color={T.green}>+ Record Payment Received</Btn>}
      </div>

      {/* Date Range */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 16, display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ color: T.muted, fontSize: 13 }}>From:</span>
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)}
            style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ color: T.muted, fontSize: 13 }}>To:</span>
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)}
            style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <KPICard icon="🛵" label="Presto Gross Sales" value={fmt(stats.prestoGross)} color={T.teal} />
        <KPICard icon="✂️" label="Presto Commission" value={fmt(stats.prestoComm)} color={T.muted} />
        <KPICard icon="💰" label="Net Amount Due" value={fmt(stats.prestoNet)} color={T.accent} />
        <KPICard icon="✅" label="Total Received" value={fmt(stats.totalReceived)} color={T.green} />
      </div>

      {/* Outstanding Balance */}
      <div style={{
        background: stats.outstanding > 0 ? T.red + "22" : T.green + "22",
        border: `2px solid ${stats.outstanding > 0 ? T.red : T.green}`,
        borderRadius: 16, padding: 24, display: "flex", justifyContent: "space-between", alignItems: "center"
      }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: stats.outstanding > 0 ? T.red : T.green }}>
            {stats.outstanding > 0 ? "🔴 Presto Balance Due" : "✅ All Settled"}
          </div>
          <div style={{ color: T.muted, fontSize: 12, marginTop: 4 }}>
            {stats.outstanding > 0 ? "Amount still owed by Presto" : "Presto has paid everything"}
          </div>
        </div>
        <div style={{ fontSize: 28, fontWeight: 900, fontFamily: "monospace", color: stats.outstanding > 0 ? T.red : T.green }}>
          {fmt(stats.outstanding)}
        </div>
      </div>

      {/* Daily Presto Breakdown */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>📋 Daily Presto Sales</div>
        {stats.daily.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No Presto sales in selected range</div>}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ color: T.muted }}>
                {["Date", "Gross Sales", "Commission", "Net Due"].map((h) => (
                  <th key={h} style={{ padding: "8px 12px", fontWeight: 600, borderBottom: `1px solid ${T.border}`, textAlign: "left" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stats.daily.map((d) => (
                <tr key={d.date} style={{ borderBottom: `1px solid ${T.border}20` }}>
                  <td style={{ padding: "10px 12px", fontWeight: 600 }}>{new Date(d.date + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</td>
                  <td style={{ padding: "10px 12px", fontFamily: "monospace", color: T.teal }}>{fmt(d.gross)}</td>
                  <td style={{ padding: "10px 12px", fontFamily: "monospace", color: T.muted }}>{fmt(d.comm)}</td>
                  <td style={{ padding: "10px 12px", fontFamily: "monospace", fontWeight: 700, color: T.accent }}>{fmt(d.net)}</td>
                </tr>
              ))}
            </tbody>
            {stats.daily.length > 0 && (
              <tfoot>
                <tr style={{ background: T.surface }}>
                  <td style={{ padding: "10px 12px", fontWeight: 800 }}>TOTAL</td>
                  <td style={{ padding: "10px 12px", fontFamily: "monospace", fontWeight: 800, color: T.teal }}>{fmt(stats.prestoGross)}</td>
                  <td style={{ padding: "10px 12px", fontFamily: "monospace", fontWeight: 800, color: T.muted }}>{fmt(stats.prestoComm)}</td>
                  <td style={{ padding: "10px 12px", fontFamily: "monospace", fontWeight: 800, color: T.accent }}>{fmt(stats.prestoNet)}</td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {/* Payments Received */}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ fontWeight: 700 }}>✅ Payments Received from Presto</div>
          {role === "admin" && <Btn small onClick={() => setAddPaymentModal(true)} color={T.green}>+ Add</Btn>}
        </div>
        {filteredPayments.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No payments recorded in selected range</div>}
        {filteredPayments.map((p) => (
          <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${T.border}30` }}>
            <div>
              <div style={{ fontWeight: 600 }}>{new Date(p.date + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</div>
              {p.note && <div style={{ color: T.muted, fontSize: 12 }}>{p.note}</div>}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontFamily: "monospace", fontWeight: 800, color: T.green }}>{fmt(p.amount)}</span>
              {role === "admin" && (
                <button onClick={() => deletePayment(p.id)} style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑</button>
              )}
            </div>
          </div>
        ))}
        {filteredPayments.length > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, paddingTop: 12, borderTop: `1px solid ${T.border}` }}>
            <span style={{ fontWeight: 700 }}>Total Received</span>
            <span style={{ fontFamily: "monospace", fontWeight: 800, color: T.green }}>{fmt(stats.totalReceived)}</span>
          </div>
        )}
      </div>

      {/* Add Payment Modal */}
      {addPaymentModal && (
        <Modal title="Record Payment Received from Presto" onClose={() => { setAddPaymentModal(false); setPaymentAmount(""); setPaymentDate(today()); setPaymentNote(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Amount Received (LYD)" type="number" value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)} placeholder="0" />
            <Input label="Date Received" type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
            <Input label="Note (optional)" value={paymentNote} onChange={(e) => setPaymentNote(e.target.value)} placeholder="e.g. Weekly settlement" />
            <Btn onClick={addPayment} full color={T.green}>Record Payment</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
function Reports({ salesRecords, procRecords, wageRecords, monthlyExpenses, staff, menuCategories, procurementCategories }) {
  const [reportMonth, setReportMonth] = useState(monthKey());
  const [reportFromDate, setReportFromDate] = useState(`${monthKey()}-01`);
  const [reportToDate, setReportToDate] = useState(today());
  const [reportType, setReportType] = useState("monthly");
  const [reportDate, setReportDate] = useState(today());
  const [procFromDate, setProcFromDate] = useState(`${monthKey()}-01`);
  const [procToDate, setProcToDate] = useState(today());
  const [revenueTooltip, setRevenueTooltip] = useState(null);
  const [profitTooltip, setProfitTooltip] = useState(null);

  const allMenuItems = useMemo(() => menuCategories.flatMap((c) => c.items.map((i) => ({ ...i, categoryId: c.id, categoryName: c.name }))), [menuCategories]);

  // ── Monthly stats ──────────────────────────────────────────────────────────
  const monthlyStats = useMemo(() => {
    const start = new Date(reportFromDate);
    const end = new Date(reportToDate);
    const daysInMonth = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
    const allDates = [];
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      allDates.push(d.toISOString().split("T")[0]);
    }

    const dailyData = allDates.map((date) => {
      const s = salesRecords[date];
      const p = procRecords[date];
      const w = wageRecords[date];
      let storeRev = 0, prestoRev = 0, prestoComm = 0, procCost = 0, wagesCost = 0;
      if (s) {
        allMenuItems.forEach((item) => {
          storeRev += (s.storeItems?.[item.id] || 0) * item.price;
        });
        (s.prestoEntries || []).forEach((e) => {
          prestoRev += e.amount;
          prestoComm += e.amount * e.commission / 100;
        });
      }
      if (p) p.items?.forEach((i) => { procCost += Number(i.qty) * Number(i.cost); });
      if (w) w.wages?.filter((wg) => wg.present).forEach((wg) => { wagesCost += Number(wg.amount) || 0; });
      const totalRev = storeRev;
      const totalExp = procCost + wagesCost + prestoComm;
      return { date, storeRev, prestoRev, prestoComm, procCost, wagesCost, totalRev, totalExp, netProfit: totalRev - totalExp, hasData: !!(s || p || w) };
    });

    const recorded = dailyData.filter((d) => d.hasData);
    const withSales = recorded.filter((d) => d.storeRev > 0);
    const totalRev = withSales.reduce((a, d) => a + d.totalRev, 0);
    const totalStore = withSales.reduce((a, d) => a + d.storeRev, 0);
    const totalPresto = withSales.reduce((a, d) => a + d.prestoRev, 0);
    const totalPrestoComm = withSales.reduce((a, d) => a + d.prestoComm, 0);
    const totalProc = recorded.reduce((a, d) => a + d.procCost, 0);
    const totalWages = recorded.reduce((a, d) => a + d.wagesCost, 0);
    const monthExp = monthlyExpenses.filter((e) => e.yearMonth >= reportFromDate.slice(0, 7) && e.yearMonth <= reportToDate.slice(0, 7));
    const salariesPaid = monthExp.filter((e) => e.category === "Salary" && e.paid).reduce((a, e) => a + Number(e.amount), 0);
    const rentsPaid = monthExp.filter((e) => e.rentId && e.paid).reduce((a, e) => a + Number(e.amount), 0);
    const otherExp = monthExp.filter((e) => e.category !== "Salary" && !e.rentId).reduce((a, e) => a + Number(e.amount), 0);
    const totalMonthlyFixed = salariesPaid + rentsPaid + otherExp;
    const totalExpenses = totalProc + totalWages + totalMonthlyFixed;
    const grossProfit = totalRev - totalProc;
    const netProfit = totalRev - totalExpenses - totalPrestoComm;
    const bestDay = withSales.filter((d) => d.storeRev > 0).reduce((a, d) => d.storeRev > (a?.storeRev || -Infinity) ? d : a, null);
    const worstDay = withSales.filter((d) => d.storeRev > 0).reduce((a, d) => d.storeRev < (a?.storeRev || Infinity) ? d : a, null);

    // Top items
    const itemSales = {};
    recorded.forEach((d) => {
      const s = salesRecords[d.date];
      if (!s) return;
      allMenuItems.forEach((item) => {
        const qty = (s.storeItems?.[item.id] || 0) + (s.prestoItems?.[item.id] || 0);
        if (qty) {
          if (!itemSales[item.id]) itemSales[item.id] = { name: item.name, qty: 0, rev: 0 };
          itemSales[item.id].qty += qty;
          itemSales[item.id].rev += qty * item.price;
        }
      });
    });
    const topItems = Object.values(itemSales).sort((a, b) => b.rev - a.rev).slice(0, 10);

    return {
      dailyData, recorded, totalRev, totalStore, totalPresto, totalPrestoComm,
      totalProc, totalWages, salariesPaid, rentsPaid, otherExp,
      totalMonthlyFixed, totalExpenses, grossProfit, netProfit,
      netMargin: totalRev > 0 ? (netProfit / totalRev) * 100 : 0,
      grossMargin: totalRev > 0 ? (grossProfit / totalRev) * 100 : 0,
      bestDay, worstDay, topItems,
      avgDailyRev: withSales.length > 0 ? totalRev / withSales.length : 0,
      daysRecorded: withSales.length, daysInMonth,
    };
  }, [reportFromDate, reportToDate, salesRecords, procRecords, wageRecords, monthlyExpenses, allMenuItems]);

  // ── Daily stats ────────────────────────────────────────────────────────────
  const dailyStats = useMemo(() => {
    const s = salesRecords[reportDate];
    const p = procRecords[reportDate];
    const w = wageRecords[reportDate];
    let storeItems = [], prestoItems = [], storeRev = 0, prestoRev = 0, prestoComm = 0;
    if (s) {
      allMenuItems.forEach((item) => {
        const sq = s.storeItems?.[item.id] || 0;
        if (sq) { storeItems.push({ ...item, qty: sq, total: sq * item.price }); storeRev += sq * item.price; }
      });
      (s.prestoEntries || []).forEach((e) => {
        prestoRev += e.amount;
        prestoComm += e.amount * e.commission / 100;
      });
    }
    const procItems = p?.items || [];
    const procCost = procItems.reduce((a, i) => a + (Number(i.qty) * Number(i.cost)), 0);
    const wages = w?.wages?.filter((wg) => wg.present) || [];
    const wagesCost = wages.reduce((a, wg) => a + Number(wg.amount), 0);
    const totalRev = storeRev + prestoRev;
    const totalExp = procCost + wagesCost + prestoComm;
    return { storeItems, prestoItems, procItems, wages, storeRev, prestoRev, prestoComm, procCost, wagesCost, totalRev, totalExp, netProfit: totalRev - totalExp };
  }, [reportDate, salesRecords, procRecords, wageRecords, allMenuItems]);

  // ── Procurement Excel Export ───────────────────────────────────────────────
  const exportProcExcel = async () => {
    const ExcelJS = await import("exceljs");
    const wb = new ExcelJS.Workbook();
    wb.creator = "Falafel Al Bayt";
    wb.created = new Date();

    const navyBlue = "1B2B4B";
    const accentBlue = "4D9FFF";
    const lightBlue = "EEF4FF";
    const yellow = "FBBF24";
    const teal = "10D9A0";

    const addSheet = (name, headers, rows, colWidths) => {
      const ws = wb.addWorksheet(name, { views: [{ state: "frozen", ySplit: 1 }] });
      ws.columns = headers.map((h, i) => ({ header: h, key: `c${i}`, width: colWidths?.[i] || 22 }));
      const headerRow = ws.getRow(1);
      headerRow.height = 28;
      headerRow.eachCell((cell) => {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { bottom: { style: "medium", color: { argb: "FF" + accentBlue } } };
      });
      rows.forEach((row, idx) => {
        const dataRow = ws.addRow(row);
        dataRow.height = 20;
        dataRow.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: idx % 2 === 0 ? "FF" + lightBlue : "FFFFFFFF" } };
          cell.alignment = { vertical: "middle" };
          cell.border = { bottom: { style: "thin", color: { argb: "FFDDDDDD" } } };
        });
      });
      return ws;
    };

    const addTotalsRow = (ws, numCols, startCol, dataRowCount) => {
      const totalsRow = ws.addRow([]);
      totalsRow.height = 24;
      const dataStart = 2;
      const dataEnd = dataStart + dataRowCount - 1;
      for (let c = 1; c <= numCols; c++) {
        const cell = totalsRow.getCell(c);
        if (c === 1) {
          cell.value = "TOTAL";
        } else if (c >= startCol) {
          const col = ws.getColumn(c);
          const colLetter = col.letter;
          cell.value = { formula: `SUBTOTAL(9,${colLetter}${dataStart}:${colLetter}${dataEnd})` };
          cell.numFmt = '#,##0.00';
        }
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.alignment = { vertical: "middle" };
      }
    };

    // Sheet 1: Summary by Category
    const catRows = procStats.categories.map((cat) => [
      cat.name,
      cat.totalCost,
      procStats.totalProcCost > 0 ? ((cat.totalCost / procStats.totalProcCost) * 100).toFixed(1) + "%" : "0%",
    ]);
    const catWs = addSheet("By Category", ["Category", "Total Cost (LYD)", "% of Total"], catRows, [25, 20, 15]);
    if (catRows.length > 0) addTotalsRow(catWs, 2, 2, catRows.length);

    // Sheet 2: All Items by Cost
    const byCostRows = procStats.allItemsByCost.map((item, i) => [
      i + 1, item.name, item.categoryName, item.totalQty + " " + item.unit, item.totalCost,
    ]);
    const byCostWs = addSheet("Items by Cost", ["Rank", "Item", "Category", "Total Qty", "Total Cost (LYD)"], byCostRows, [8, 25, 20, 15, 20]);
    if (byCostRows.length > 0) addTotalsRow(byCostWs, 5, 5, byCostRows.length);

    // Sheet 3: All Items by Quantity
    const byQtyRows = procStats.allItemsByQty.map((item, i) => [
      i + 1, item.name, item.categoryName, item.totalQty, item.unit, item.totalCost,
    ]);
    const byQtyWs = addSheet("Items by Quantity", ["Rank", "Item", "Category", "Total Qty", "Unit", "Total Cost (LYD)"], byQtyRows, [8, 25, 20, 12, 10, 20]);
    if (byQtyRows.length > 0) addTotalsRow(byQtyWs, 6, 6, byQtyRows.length);

    // Sheet 4: Daily Procurement Detail
    const dailyRows = [];
    Object.values(procRecords)
      .filter((r) => r.date >= procFromDate && r.date <= procToDate)
      .sort((a, b) => a.date.localeCompare(b.date))
      .forEach((r) => {
        r.items?.forEach((item) => {
          const currentProcItem = (procurementCategories || []).flatMap((c) => c.items).find((i) => i.id === item.id);
          dailyRows.push([
            r.date, item.categoryName, item.name, item.qty, currentProcItem?.unit || item.unit || "", item.cost,
            Number(item.qty) * Number(item.cost),
          ]);
        });
      });
    const dailyDetailWs = addSheet("Daily Detail", ["Date", "Category", "Item", "Qty", "Unit", "Unit Price (LYD)", "Total Cost (LYD)"], dailyRows, [14, 20, 24, 10, 8, 18, 18]);
    if (dailyRows.length > 0) addTotalsRow(dailyDetailWs, 7, 7, dailyRows.length);

    // Summary sheet
    const summaryWs = wb.addWorksheet("Summary");
    summaryWs.columns = [{ width: 30 }, { width: 20 }];
    const titleRow = summaryWs.addRow(["Falafel Al Bayt — Procurement Report", ""]);
    summaryWs.mergeCells("A1:B1");
    titleRow.height = 36;
    titleRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
    titleRow.getCell(1).font = { bold: true, color: { argb: "FFFFFFFF" }, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
    const rangeRow = summaryWs.addRow([`Period: ${procFromDate} to ${procToDate}`, `Days: ${procStats.daysRecorded}`]);
    rangeRow.eachCell((cell) => { cell.font = { italic: true, color: { argb: "FF" + navyBlue } }; });
    summaryWs.addRow([]);
    const totalRow = summaryWs.addRow(["Total Procurement Cost", procStats.totalProcCost]);
    totalRow.eachCell((cell) => { cell.font = { bold: true, size: 12 }; cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + lightBlue } }; });
    summaryWs.addRow([]);
    const catHeader = summaryWs.addRow(["Category Breakdown", ""]);
    catHeader.eachCell((cell) => { cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } }; cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; });
    procStats.categories.forEach((cat) => { summaryWs.addRow([cat.name, cat.totalCost]); });

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `FalafelAlBayt_Procurement_${procFromDate}_to_${procToDate}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── Excel Export ───────────────────────────────────────────────────────────
  const exportExcel = async () => {
    const ExcelJS = await import("exceljs");
    const wb = new ExcelJS.Workbook();
    wb.creator = "Falafel Al Bayt";
    wb.created = new Date();

    const navyBlue = "1B2B4B";
    const accentBlue = "4D9FFF";
    const lightBlue = "EEF4FF";
    const green = "10D9A0";
    const red = "F4566A";
    const yellow = "FBBF24";

    const addSheet = (name, headers, rows, colWidths) => {
      const ws = wb.addWorksheet(name, { views: [{ state: "frozen", ySplit: 1 }] });
      ws.columns = headers.map((h, i) => ({ header: h, key: `c${i}`, width: colWidths?.[i] || 22 }));

      // Style header row
      const headerRow = ws.getRow(1);
      headerRow.height = 28;
      headerRow.eachCell((cell) => {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { bottom: { style: "medium", color: { argb: "FF" + accentBlue } } };
      });

      // Add data rows
      rows.forEach((row, idx) => {
        const dataRow = ws.addRow(row);
        dataRow.height = 20;
        dataRow.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: idx % 2 === 0 ? "FF" + lightBlue : "FFFFFFFF" } };
          cell.alignment = { vertical: "middle" };
          cell.border = { bottom: { style: "thin", color: { argb: "FFDDDDDD" } } };
        });
      });

      return ws;
    };

   const addTotalsRow = (ws, numCols, startCol, dataRowCount) => {
      const totalsRow = ws.addRow([]);
      totalsRow.height = 24;
      const dataStart = 2;
      const dataEnd = dataStart + dataRowCount - 1;
      for (let c = 1; c <= numCols; c++) {
        const cell = totalsRow.getCell(c);
        if (c === 1) {
          cell.value = "TOTAL";
        } else if (c >= startCol) {
          const col = ws.getColumn(c);
          const colLetter = col.letter;
          cell.value = { formula: `SUBTOTAL(9,${colLetter}${dataStart}:${colLetter}${dataEnd})` };
          cell.numFmt = '#,##0.00';
        }
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.alignment = { vertical: "middle" };
      }
    };

    // ── Sales by Item Sheet ──────────────────────────────────────────────────
    const salesByItemRows = [];
    Object.values(salesRecords).sort((a, b) => a.date.localeCompare(b.date)).forEach((r) => {
      allMenuItems.forEach((item) => {
        const storeQty = r.storeItems?.[item.id] || 0;
        if (storeQty > 0) {
          salesByItemRows.push([r.date, item.categoryName, item.name, storeQty, storeQty * item.price]);
        }
      });
    });
    const salesByItemWs = addSheet("Sales by Item",
      ["Date", "Category", "Item", "Store Qty", "Store Revenue (LYD)"],
      salesByItemRows, [14, 22, 24, 12, 20]);
    if (salesByItemRows.length > 0) addTotalsRow(salesByItemWs, 5, 4, salesByItemRows.length);

    // ── Sales Sheet ──────────────────────────────────────────────────────────
    const salesRows = Object.values(salesRecords).sort((a, b) => a.date.localeCompare(b.date)).map((r) => {
      let storeRev = 0;
      allMenuItems.forEach((item) => {
        storeRev += (r.storeItems?.[item.id] || 0) * item.price;
      });
      const prestoRev = (r.prestoEntries || []).reduce((a, e) => a + e.amount, 0);
      const prestoComm = (r.prestoEntries || []).reduce((a, e) => a + e.amount * e.commission / 100, 0);
      return [r.date, storeRev, prestoRev, prestoComm, storeRev, storeRev - prestoComm];
    });
    const salesWs = addSheet("Sales",
      ["Date", "Store Sales (LYD)", "Presto Sales (LYD)", "Presto Commission (LYD)", "Total Revenue (LYD)", "Net After Commission (LYD)"],
      salesRows, [15, 20, 20, 22, 20, 20]);
    if (salesRows.length > 0) addTotalsRow(salesWs, 6, 2, salesRows.length);

    // ── Procurement Sheet ────────────────────────────────────────────────────
    const procRows = [];
    Object.values(procRecords).sort((a, b) => a.date.localeCompare(b.date)).forEach((r) => {
      r.items?.forEach((i) => procRows.push([r.date, i.categoryName, i.name, i.qty, i.cost, Number(i.qty) * Number(i.cost)]));
    });
    const procWs = addSheet("Procurement",
      ["Date", "Category", "Item", "Qty", "Unit Price (LYD)", "Total Cost (LYD)"],
      procRows, [15, 18, 22, 10, 18, 18]);
    if (procRows.length > 0) addTotalsRow(procWs, 6, 4, procRows.length);

    // ── Daily Wages Sheet ────────────────────────────────────────────────────
    const wagesRows = [];
    Object.values(wageRecords).sort((a, b) => a.date.localeCompare(b.date)).forEach((r) => {
      r.wages?.forEach((w) => wagesRows.push([r.date, w.name, w.present ? w.amount : 0, w.present ? "Present" : "Absent"]));
    });
    const wagesWs = addSheet("Daily Wages",
      ["Date", "Staff Name", "Amount (LYD)", "Status"],
      wagesRows, [15, 22, 18, 14]);
    if (wagesRows.length > 0) addTotalsRow(wagesWs, 3, 3, wagesRows.length);

    // Color status column
    wagesWs.eachRow((row, rowIdx) => {
      if (rowIdx > 1) {
        const statusCell = row.getCell(4);
        if (typeof statusCell.value === "string") {
          statusCell.font = { bold: true, color: { argb: statusCell.value === "Present" ? "FF" + green : "FF" + red } };
        }
      }
    });

    // ── Monthly Salaries Sheet ───────────────────────────────────────────────
    const salariesRows = monthlyExpenses.filter((e) => e.category === "Salary").map((e) => {
      const s = staff.find((st) => st.id === e.staffId);
      return [e.yearMonth, e.staffName, s?.role || "", s?.monthlyRate || 0, e.amount, e.paidDate || "", e.paid ? "Paid" : "Pending"];
    });
    const salWs = addSheet("Monthly Salaries",
      ["Month", "Staff Name", "Role", "Base Salary (LYD)", "Amount Paid (LYD)", "Date Paid", "Status"],
      salariesRows, [14, 20, 16, 20, 20, 14, 12]);

    salWs.eachRow((row, rowIdx) => {
      if (rowIdx > 1) {
        const statusCell = row.getCell(7);
        statusCell.font = { bold: true, color: { argb: statusCell.value === "Paid" ? "FF" + green : "FF" + yellow } };
      }
    });

    // ── Rents Sheet ──────────────────────────────────────────────────────────
    const rentsRows = monthlyExpenses.filter((e) => e.rentId).map((e) => [e.yearMonth, e.description, e.amount, e.paidDate || "", e.paid ? "Paid" : "Pending"]);
    const rentsWs = addSheet("Rents",
      ["Month", "Rent Name", "Amount (LYD)", "Date Paid", "Status"],
      rentsRows, [14, 24, 16, 14, 12]);

    rentsWs.eachRow((row, rowIdx) => {
      if (rowIdx > 1) {
        const statusCell = row.getCell(5);
        statusCell.font = { bold: true, color: { argb: statusCell.value === "Paid" ? "FF" + green : "FF" + yellow } };
      }
    });

    // ── Summary Sheet ────────────────────────────────────────────────────────
    const summaryWs = wb.addWorksheet("Summary", { views: [{ state: "frozen", ySplit: 2 }] });
    summaryWs.columns = [{ width: 30 }, { width: 20 }];

    const addSummaryRow = (label, value, style) => {
      const row = summaryWs.addRow([label, value]);
      row.height = 22;
      if (style === "section") {
        row.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
          cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
          cell.alignment = { vertical: "middle" };
        });
      } else if (style === "total") {
        row.eachCell((cell) => {
          cell.font = { bold: true, size: 11 };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + lightBlue } };
        });
      } else if (style === "profit") {
        row.getCell(1).font = { bold: true };
        row.getCell(2).font = { bold: true, color: { argb: monthlyStats.netProfit >= 0 ? "FF" + green : "FF" + red } };
      }
    };

    // Title
    const titleRow = summaryWs.addRow(["Falafel Al Bayt — Financial Summary", ""]);
    summaryWs.mergeCells("A1:B1");
    titleRow.height = 36;
    titleRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF" + navyBlue } };
    titleRow.getCell(1).font = { bold: true, color: { argb: "FFFFFFFF" }, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };

    const monthRow = summaryWs.addRow([`Report Month: ${reportMonth}`, `Generated: ${new Date().toLocaleDateString()}`]);
    monthRow.height = 20;
    monthRow.eachCell((cell) => { cell.font = { italic: true, color: { argb: "FF" + navyBlue } }; });

    summaryWs.addRow([]);
    addSummaryRow("REVENUE", "", "section");
    addSummaryRow("Total Store Sales", monthlyStats.totalStore);
    addSummaryRow("Total Presto Sales", monthlyStats.totalPresto);
    addSummaryRow("Presto Commission Fee", monthlyStats.totalPrestoComm);
    addSummaryRow("Total Revenue", monthlyStats.totalRev, "total");
    summaryWs.addRow([]);
    addSummaryRow("EXPENSES", "", "section");
    addSummaryRow("Procurement Cost", monthlyStats.totalProc);
    addSummaryRow("Daily Wages", monthlyStats.totalWages);
    addSummaryRow("Monthly Salaries Paid", monthlyStats.salariesPaid);
    addSummaryRow("Monthly Rents Paid", monthlyStats.rentsPaid);
    addSummaryRow("Other Fixed Expenses", monthlyStats.otherExp);
    addSummaryRow("Total Expenses", monthlyStats.totalExpenses, "total");
    summaryWs.addRow([]);
    addSummaryRow("PROFIT", "", "section");
    addSummaryRow("Gross Profit", monthlyStats.grossProfit);
    addSummaryRow("Gross Margin %", monthlyStats.grossMargin.toFixed(1) + "%");
    addSummaryRow("Net Profit", monthlyStats.netProfit, "profit");
    addSummaryRow("Net Margin %", monthlyStats.netMargin.toFixed(1) + "%");
    summaryWs.addRow([]);
    addSummaryRow("PERFORMANCE", "", "section");
    addSummaryRow("Days Recorded", `${monthlyStats.daysRecorded} / ${monthlyStats.daysInMonth}`);
    addSummaryRow("Average Daily Revenue", monthlyStats.avgDailyRev);
    addSummaryRow("Best Day", monthlyStats.bestDay ? `${monthlyStats.bestDay.date} (${fmt(monthlyStats.bestDay.netProfit)})` : "N/A");
    addSummaryRow("Worst Day", monthlyStats.worstDay ? `${monthlyStats.worstDay.date} (${fmt(monthlyStats.worstDay.netProfit)})` : "N/A");

    // Download
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `FalafelAlBayt_Report_${reportMonth}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── Procurement Analytics ──────────────────────────────────────────────────
  const procStats = useMemo(() => {
    const filtered = Object.values(procRecords).filter((r) => r.date >= procFromDate && r.date <= procToDate);

    // By category
    const catMap = {};
    filtered.forEach((r) => {
      r.items?.forEach((item) => {
        if (!catMap[item.categoryId]) catMap[item.categoryId] = { name: item.categoryName, totalCost: 0, items: {} };
        catMap[item.categoryId].totalCost += Number(item.qty) * Number(item.cost);
        if (!catMap[item.categoryId].items[item.id]) {
          const currentItem = (procurementCategories || []).flatMap((c) => c.items).find((i) => i.id === item.id);
          catMap[item.categoryId].items[item.id] = { name: item.name, totalQty: 0, totalCost: 0, unit: currentItem?.unit || item.unit };
        }
        catMap[item.categoryId].items[item.id].totalQty += Number(item.qty) || 0;
        catMap[item.categoryId].items[item.id].totalCost += (Number(item.qty) * Number(item.cost)) || Number(item.totalCost) || 0;
      });
    });

    const categories = Object.values(catMap).sort((a, b) => b.totalCost - a.totalCost).map((cat) => ({
      ...cat,
      items: Object.values(cat.items).sort((a, b) => b.totalCost - a.totalCost),
    }));

    // All items flat
    const itemMap = {};
    filtered.forEach((r) => {
      r.items?.forEach((item) => {
        if (!itemMap[item.id]) {
          const currentProcItem = (procurementCategories || []).flatMap((c) => c.items).find((i) => i.id === item.id);
          itemMap[item.id] = { name: item.name, categoryName: item.categoryName, totalQty: 0, totalCost: 0, unit: currentProcItem?.unit || item.unit };
        }
        itemMap[item.id].totalQty += Number(item.qty) || 0;
        itemMap[item.id].totalCost += Number(item.qty) * Number(item.cost);
      });
    });

    const allItemsByCost = Object.values(itemMap).sort((a, b) => b.totalCost - a.totalCost);
    const allItemsByQty = Object.values(itemMap).sort((a, b) => b.totalQty - a.totalQty);
    const totalProcCost = categories.reduce((a, c) => a + c.totalCost, 0);

    return { categories, allItemsByCost, allItemsByQty, totalProcCost, daysRecorded: filtered.length };
  }, [procRecords, procFromDate, procToDate]);

  // ── Mini chart ─────────────────────────────────────────────────────────────
  const maxVal = Math.max(...monthlyStats.dailyData.map((d) => Math.abs(d.totalRev)), 1);
  const maxProfit = Math.max(...monthlyStats.dailyData.map((d) => Math.abs(d.netProfit)), 1);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>📊 Reports</div>
        <div style={{ display: "flex", gap: 8 }}>
        <Pill label="📅 Monthly" active={reportType === "monthly"} onClick={() => setReportType("monthly")} />
        <Pill label="🗓 Daily" active={reportType === "daily"} onClick={() => setReportType("daily")} />
        <Pill label="📦 Procurement" active={reportType === "procurement"} onClick={() => setReportType("procurement")} color={T.yellow} />
      </div>
      </div>

      {/* Controls */}
      {reportType !== "procurement" && <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 16, display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
        {reportType === "monthly" ? (
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: T.muted, fontSize: 13 }}>From:</span>
              <input type="date" value={reportFromDate} onChange={(e) => setReportFromDate(e.target.value)}
                style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: T.muted, fontSize: 13 }}>To:</span>
              <input type="date" value={reportToDate} onChange={(e) => setReportToDate(e.target.value)}
                style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
            </div>
          </div>
        ) : (
          <input type="date" value={reportDate} onChange={(e) => setReportDate(e.target.value)}
            style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
        )}
        <Btn onClick={exportExcel} color={T.green}>⬇️ Export Excel</Btn>
        <Btn onClick={() => window.print()} variant="ghost">🖨️ Print / Save PDF</Btn>
      </div>}

      {reportType === "monthly" && (
        <>
          {/* KPI Summary */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <KPICard icon="💰" label="Total Sales" value={fmt(monthlyStats.totalRev)} color={T.accent} sub={`${monthlyStats.daysRecorded}/${monthlyStats.daysInMonth} days recorded`} />
            <KPICard icon="📤" label="Total Expenses" value={fmt(monthlyStats.totalExpenses)} color={T.red} />
            <KPICard icon="📊" label="Gross Profit" value={fmt(monthlyStats.grossProfit)} color={T.yellow} sub={`Margin: ${monthlyStats.grossMargin.toFixed(1)}%`} />
            <KPICard icon="🏆" label="Net Profit" value={fmt(monthlyStats.netProfit)} color={monthlyStats.netProfit >= 0 ? T.green : T.red} sub={`Net Margin: ${monthlyStats.netMargin.toFixed(1)}%`} />
          </div>

          {/* Revenue & Sales Split */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <KPICard icon="🏪" label="Store Sales" value={fmt(monthlyStats.totalStore)} color={T.accentLight} />
            <KPICard icon="🛵" label="Presto Sales" value={fmt(monthlyStats.totalPresto)} color={T.teal} />
            <KPICard icon="🤝" label="Presto Commission" value={fmt(monthlyStats.totalPrestoComm)} color={T.muted} />
            <KPICard icon="📈" label="Avg Daily Sales" value={fmt(monthlyStats.avgDailyRev)} color={T.purple} />
            <KPICard icon="📉" label="Avg Daily Expenses" value={fmt(monthlyStats.daysRecorded > 0 ? monthlyStats.totalExpenses / monthlyStats.daysRecorded : 0)} color={T.red} />
          </div>

          {/* Daily Revenue Chart */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>Total Daily Sales — {reportFromDate} to {reportToDate}</div>
            <div style={{ color: T.muted, fontSize: 12, marginBottom: 14 }}>Sales per day this month</div>
            <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 100, position: "relative" }}>
              {monthlyStats.dailyData.map((d, i) => (
                <div key={i}
                  onMouseEnter={() => setRevenueTooltip({ date: d.date, value: d.totalRev, pct: (i / monthlyStats.dailyData.length) * 100 + (50 / monthlyStats.dailyData.length) })}
                  onMouseLeave={() => setRevenueTooltip(null)}
                  style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", height: "100%", position: "relative", cursor: "pointer" }}>
                  <div style={{ width: "100%", height: `${(d.totalRev / maxVal) * 90}px`, background: d.hasData ? T.accent + "CC" : T.border, borderRadius: "3px 3px 0 0", minHeight: d.hasData ? 2 : 0 }} />
                </div>
              ))}
              {revenueTooltip && (
                <div style={{
                  position: "absolute", bottom: 110, left: `${revenueTooltip.pct}%`, transform: "translateX(-50%)",
                  background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, padding: "6px 10px",
                  zIndex: 50, whiteSpace: "nowrap", pointerEvents: "none", boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
                }}>
                  <div style={{ color: T.muted, fontSize: 10, fontWeight: 700 }}>{revenueTooltip.date}</div>
                  <div style={{ color: T.accent, fontWeight: 800, fontFamily: "monospace", fontSize: 13 }}>{fmt(revenueTooltip.value)}</div>
                </div>
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, color: T.muted, fontSize: 11 }}>
              <span>{reportFromDate}</span><span>{reportToDate}</span>
            </div>
          </div>

          

          {/* Expense Breakdown */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 16 }}>Expense Breakdown</div>
            {[
              { label: "Procurement", value: monthlyStats.totalProc, color: T.yellow },
              { label: "Daily Wages", value: monthlyStats.totalWages, color: T.teal },
              { label: "Presto Commission", value: monthlyStats.totalPrestoComm, color: T.muted },
              { label: "Monthly Salaries", value: monthlyStats.salariesPaid, color: T.accent },
              { label: "Monthly Rents", value: monthlyStats.rentsPaid, color: T.purple },
              { label: "Other Expenses", value: monthlyStats.otherExp, color: T.blue },
            ].map((e) => {
              const pct = monthlyStats.totalExpenses > 0 ? (e.value / monthlyStats.totalExpenses) * 100 : 0;
              return (
                <div key={e.label} style={{ marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, fontSize: 13 }}>
                    <span style={{ fontWeight: 600 }}>{e.label}</span>
                    <span style={{ color: e.color, fontWeight: 700, fontFamily: "monospace" }}>{fmt(e.value)} <span style={{ color: T.muted, fontWeight: 400 }}>({pct.toFixed(1)}%)</span></span>
                  </div>
                  <div style={{ background: T.border, borderRadius: 99, height: 6 }}>
                    <div style={{ background: e.color, width: `${pct}%`, height: 6, borderRadius: 99 }} />
                  </div>
                </div>
              );
            })}
          </div>

          {/* Best & Worst Day */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <div style={{ flex: 1, background: T.card, border: `1px solid ${T.green}44`, borderRadius: 14, padding: 18 }}>
              <div style={{ color: T.green, fontWeight: 700, marginBottom: 8 }}>🏆 Best Day</div>
              {monthlyStats.bestDay ? <>
                <div style={{ fontWeight: 800, fontSize: 16 }}>{new Date(monthlyStats.bestDay.date + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })}</div>
                <div style={{ color: T.green, fontFamily: "monospace", fontWeight: 800, fontSize: 18, marginTop: 4 }}>{fmt(monthlyStats.bestDay.storeRev)}</div>
              </> : <div style={{ color: T.muted }}>No data</div>}
            </div>
            <div style={{ flex: 1, background: T.card, border: `1px solid ${T.red}44`, borderRadius: 14, padding: 18 }}>
              <div style={{ color: T.red, fontWeight: 700, marginBottom: 8 }}>📉 Worst Day</div>
              {monthlyStats.worstDay ? <>
                <div style={{ fontWeight: 800, fontSize: 16 }}>{new Date(monthlyStats.worstDay.date + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })}</div>
                <div style={{ color: T.red, fontFamily: "monospace", fontWeight: 800, fontSize: 18, marginTop: 4 }}>{fmt(monthlyStats.worstDay.storeRev)}</div>
              </> : <div style={{ color: T.muted }}>No data</div>}
            </div>
          </div>

          {/* Top Items */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 16 }}>🥇 Top Selling Items — {reportMonth}</div>
            {monthlyStats.topItems.map((item, i) => {
              const maxRev = monthlyStats.topItems[0]?.rev || 1;
              return (
                <div key={item.name} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                  <span style={{ color: T.muted, fontSize: 12, fontWeight: 700, width: 20, textAlign: "right" }}>{i + 1}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, fontSize: 13 }}>
                      <span style={{ fontWeight: 600 }}>{item.name}</span>
                      <span style={{ color: T.accent, fontFamily: "monospace", fontWeight: 700 }}>{fmt(item.rev)} <span style={{ color: T.muted }}>({item.qty} sold)</span></span>
                    </div>
                    <div style={{ background: T.border, borderRadius: 99, height: 5 }}>
                      <div style={{ background: `linear-gradient(90deg, ${T.accent}, ${T.accentLight})`, width: `${(item.rev / maxRev) * 100}%`, height: 5, borderRadius: 99 }} />
                    </div>
                  </div>
                </div>
              );
            })}
            {monthlyStats.topItems.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No sales data for {reportMonth}</div>}
          </div>

          {/* Daily Summary Table */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>📋 Daily Summary Table</div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ color: T.muted }}>
                    {["Date", "Store", "Presto", "Commission", "Revenue", "Proc Cost", "Wages", "Net Profit"].map((h) => (
                      <th key={h} style={{ padding: "8px 10px", fontWeight: 600, borderBottom: `1px solid ${T.border}`, textAlign: "left", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {monthlyStats.dailyData.filter((d) => d.hasData).map((d) => (
                    <tr key={d.date} style={{ borderBottom: `1px solid ${T.border}20` }}>
                      <td style={{ padding: "8px 10px", fontWeight: 600 }}>{new Date(d.date + "T12:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" })}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", color: T.accent }}>{fmt(d.storeRev)}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", color: T.teal }}>{fmt(d.prestoRev)}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", color: T.muted }}>{fmt(d.prestoComm)}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", fontWeight: 700 }}>{fmt(d.totalRev)}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", color: T.yellow }}>{fmt(d.procCost)}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", color: T.teal }}>{fmt(d.wagesCost)}</td>
                      <td style={{ padding: "8px 10px", fontFamily: "monospace", fontWeight: 800, color: d.netProfit >= 0 ? T.green : T.red }}>{fmt(d.netProfit)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Monthly Fixed Costs Summary */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 16 }}>💼 Monthly Fixed Costs</div>
            {[
              { label: "Monthly Salaries", value: monthlyStats.salariesPaid, color: T.accent },
              { label: "Monthly Rents", value: monthlyStats.rentsPaid, color: T.purple },
              { label: "Other Expenses", value: monthlyStats.otherExp, color: T.yellow },
            ].map((item) => (
              <div key={item.label} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: `1px solid ${T.border}30` }}>
                <span style={{ fontWeight: 600 }}>{item.label}</span>
                <span style={{ fontFamily: "monospace", fontWeight: 700, color: item.color }}>{fmt(item.value)}</span>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, paddingTop: 12, borderTop: `1px solid ${T.border}` }}>
              <span style={{ fontWeight: 800 }}>Total Fixed</span>
              <span style={{ fontFamily: "monospace", fontWeight: 800, color: T.red }}>{fmt(monthlyStats.totalMonthlyFixed)}</span>
            </div>
          </div>
        </>
      )}


{reportType === "procurement" && (
        <>
          {/* Date Range */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 16, display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ color: T.muted, fontSize: 13 }}>From:</span>
              <input type="date" value={procFromDate} onChange={(e) => setProcFromDate(e.target.value)}
                style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ color: T.muted, fontSize: 13 }}>To:</span>
              <input type="date" value={procToDate} onChange={(e) => setProcToDate(e.target.value)}
                style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "9px 14px", fontSize: 14, fontFamily: "inherit" }} />
            </div>
            <Btn onClick={exportProcExcel} color={T.green}>⬇️ Export Excel</Btn>
          </div>

          {/* KPIs */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <KPICard icon="📦" label="Total Procurement Cost" value={fmt(procStats.totalProcCost)} color={T.yellow} sub={`${procStats.daysRecorded} days recorded`} />
            <KPICard icon="🏆" label="Top Category" value={procStats.categories[0]?.name || "N/A"} color={T.accent} sub={procStats.categories[0] ? fmt(procStats.categories[0].totalCost) : ""} />
            <KPICard icon="🥇" label="Most Expensive Item" value={procStats.allItemsByCost[0]?.name || "N/A"} color={T.red} sub={procStats.allItemsByCost[0] ? fmt(procStats.allItemsByCost[0].totalCost) : ""} />
            <KPICard icon="📊" label="Most Purchased Item" value={procStats.allItemsByQty[0]?.name || "N/A"} color={T.teal} sub={procStats.allItemsByQty[0] ? `${procStats.allItemsByQty[0].totalQty} ${procStats.allItemsByQty[0].unit}` : ""} />
          </div>

          {/* Cost by Category Chart */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 16 }}>💰 Total Cost by Category</div>
            {procStats.categories.map((cat) => {
              const pct = procStats.totalProcCost > 0 ? (cat.totalCost / procStats.totalProcCost) * 100 : 0;
              return (
                <div key={cat.name} style={{ marginBottom: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5, fontSize: 13 }}>
                    <span style={{ fontWeight: 600 }}>{cat.name}</span>
                    <span style={{ color: T.yellow, fontWeight: 700, fontFamily: "monospace" }}>{fmt(cat.totalCost)} <span style={{ color: T.muted }}>({pct.toFixed(1)}%)</span></span>
                  </div>
                  <div style={{ background: T.border, borderRadius: 99, height: 8 }}>
                    <div style={{ background: T.yellow, width: `${pct}%`, height: 8, borderRadius: 99 }} />
                  </div>
                </div>
              );
            })}
            {procStats.categories.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No procurement data for selected range</div>}
          </div>

          {/* By Category Detail */}
          {procStats.categories.map((cat) => (
            <div key={cat.name} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
              <div style={{ fontWeight: 700, marginBottom: 14 }}>{cat.name} — {fmt(cat.totalCost)}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 120px 120px", gap: "8px 12px", alignItems: "center" }}>
                <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Item</div>
                <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Total Qty</div>
                <div style={{ color: T.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Total Cost</div>
                {cat.items.map((item) => {
                  const maxCost = cat.items[0]?.totalCost || 1;
                  return [
                    <div key={item.name + "_n"}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{item.name}</div>
                      <div style={{ background: T.border, borderRadius: 99, height: 4, marginTop: 4 }}>
                        <div style={{ background: T.yellow, width: `${(item.totalCost / maxCost) * 100}%`, height: 4, borderRadius: 99 }} />
                      </div>
                    </div>,
                    <div key={item.name + "_q"} style={{ fontFamily: "monospace", fontWeight: 700, color: T.teal }}>{item.totalQty} {item.unit}</div>,
                    <div key={item.name + "_c"} style={{ fontFamily: "monospace", fontWeight: 700, color: T.yellow }}>{fmt(item.totalCost)}</div>,
                  ];
                })}
              </div>
            </div>
          ))}

          {/* All Items by Cost */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 16 }}>💸 All Items Ranked by Cost</div>
            {procStats.allItemsByCost.map((item, i) => {
              const maxCost = procStats.allItemsByCost[0]?.totalCost || 1;
              return (
                <div key={item.name + i} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                  <span style={{ color: T.muted, fontSize: 12, fontWeight: 700, width: 24, textAlign: "right" }}>{i + 1}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, fontSize: 13 }}>
                      <span style={{ fontWeight: 600 }}>{item.name} <span style={{ color: T.muted, fontWeight: 400 }}>({item.categoryName})</span></span>
                      <span style={{ color: T.yellow, fontFamily: "monospace", fontWeight: 700 }}>{fmt(item.totalCost)}</span>
                    </div>
                    <div style={{ background: T.border, borderRadius: 99, height: 5 }}>
                      <div style={{ background: T.yellow, width: `${(item.totalCost / maxCost) * 100}%`, height: 5, borderRadius: 99 }} />
                    </div>
                  </div>
                </div>
              );
            })}
            {procStats.allItemsByCost.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No data</div>}
          </div>

          {/* All Items by Quantity */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 16 }}>📦 All Items Ranked by Quantity</div>
            {procStats.allItemsByQty.map((item, i) => {
              const maxQty = procStats.allItemsByQty[0]?.totalQty || 1;
              return (
                <div key={item.name + i} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                  <span style={{ color: T.muted, fontSize: 12, fontWeight: 700, width: 24, textAlign: "right" }}>{i + 1}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, fontSize: 13 }}>
                      <span style={{ fontWeight: 600 }}>{item.name} <span style={{ color: T.muted, fontWeight: 400 }}>({item.categoryName})</span></span>
                      <span style={{ color: T.teal, fontFamily: "monospace", fontWeight: 700 }}>{item.totalQty} {item.unit}</span>
                    </div>
                    <div style={{ background: T.border, borderRadius: 99, height: 5 }}>
                      <div style={{ background: T.teal, width: `${(item.totalQty / maxQty) * 100}%`, height: 5, borderRadius: 99 }} />
                    </div>
                  </div>
                </div>
              );
            })}
            {procStats.allItemsByQty.length === 0 && <div style={{ color: T.muted, textAlign: "center", padding: 20 }}>No data</div>}
          </div>
        </>
      )}

      {reportType === "daily" && (
        <>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <KPICard icon="💰" label="Total Revenue" value={fmt(dailyStats.totalRev)} color={T.accent} />
            <KPICard icon="📤" label="Total Expenses" value={fmt(dailyStats.totalExp)} color={T.red} />
            <KPICard icon="🏆" label="Net Profit" value={fmt(dailyStats.netProfit)} color={dailyStats.netProfit >= 0 ? T.green : T.red} />
          </div>

          {/* Store Sales */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>🏪 Store Sales — {fmt(dailyStats.storeRev)}</div>
            {dailyStats.storeItems.length === 0 && <div style={{ color: T.muted }}>No store sales recorded</div>}
            {dailyStats.storeItems.map((item) => (
              <div key={item.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}20`, fontSize: 13 }}>
                <span>{item.name}</span>
                <span style={{ fontFamily: "monospace" }}>{item.qty} × {item.price} = <strong style={{ color: T.accent }}>{fmt(item.total)}</strong></span>
              </div>
            ))}
          </div>

          {/* Presto Sales */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>🛵 Presto Sales — {fmt(dailyStats.prestoRev)} (Commission: {fmt(dailyStats.prestoComm)})</div>
            {dailyStats.prestoItems.length === 0 && <div style={{ color: T.muted }}>No presto sales recorded</div>}
            {dailyStats.prestoItems.map((item) => (
              <div key={item.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}20`, fontSize: 13 }}>
                <span>{item.name}</span>
                <span style={{ fontFamily: "monospace" }}>{item.qty} × {item.price} = <strong style={{ color: T.teal }}>{fmt(item.total)}</strong></span>
              </div>
            ))}
          </div>

          {/* Procurement */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>📦 Procurement — {fmt(dailyStats.procCost)}</div>
            {dailyStats.procItems.length === 0 && <div style={{ color: T.muted }}>No procurement recorded</div>}
            {dailyStats.procItems.map((item, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}20`, fontSize: 13 }}>
                <span>{item.name} <span style={{ color: T.muted }}>({item.qty} {item.unit})</span></span>
                <strong style={{ color: T.yellow, fontFamily: "monospace" }}>{fmt(item.totalCost || (item.cost * item.qty))}</strong>
              </div>
            ))}
          </div>

          {/* Wages */}
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>👷 Daily Wages — {fmt(dailyStats.wagesCost)}</div>
            {dailyStats.wages.length === 0 && <div style={{ color: T.muted }}>No wages recorded</div>}
            {dailyStats.wages.map((w, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}20`, fontSize: 13 }}>
                <span>{w.name}</span>
                <strong style={{ color: T.teal, fontFamily: "monospace" }}>{fmt(w.amount)}</strong>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}



// ═══════════════════════════════════════════════════════════════════════════════
// SETTINGS
// ═══════════════════════════════════════════════════════════════════════════════
function Settings({ menuCategories, setMenuCategories, procurementCategories, setProcurementCategories, staff, setStaff, showToast }) {
  const [settingsTab, setSettingsTab] = useState("menu");
  const [editItem, setEditItem] = useState(null);
  const [editPrice, setEditPrice] = useState("");
  const [editName, setEditName] = useState("");
  const [editNameAr, setEditNameAr] = useState("");
  const [addItemModal, setAddItemModal] = useState(null);
  const [newItemName, setNewItemName] = useState("");
  const [newItemNameAr, setNewItemNameAr] = useState("");
  const [newItemPrice, setNewItemPrice] = useState("");

  const saveNewItem = () => {
    if (!newItemName || !newItemPrice) return;
    const newItem = {
      id: genId(),
      name: newItemName,
      nameAr: newItemNameAr,
      price: Number(newItemPrice),
    };
    setMenuCategories((prev) =>
      prev.map((cat) =>
        cat.id === addItemModal ? { ...cat, items: [...cat.items, newItem] } : cat
      )
    );
    setAddItemModal(null);
    setNewItemName(""); setNewItemNameAr(""); setNewItemPrice("");
    showToast("Item added! ✅", "success");
  };

  const procCategories = procurementCategories;
  const setProcCategories = setProcurementCategories;
  const [addProcItemModal, setAddProcItemModal] = useState(null);
  const [newProcName, setNewProcName] = useState("");
  const [newProcNameAr, setNewProcNameAr] = useState("");
  const [editProcItem, setEditProcItem] = useState(null);
  const [editProcName, setEditProcName] = useState("");
  const [editProcNameAr, setEditProcNameAr] = useState("");
  const [editProcUnit, setEditProcUnit] = useState("kg");

  const saveNewProcItem = () => {
    if (!newProcName) return;
    const newItem = { id: genId(), name: newProcName, nameAr: newProcNameAr };
    setProcCategories((prev) =>
      prev.map((cat) =>
        cat.id === addProcItemModal ? { ...cat, items: [...cat.items, newItem] } : cat
      )
    );
    setAddProcItemModal(null);
    setNewProcName(""); setNewProcNameAr("");
    showToast("Procurement item added! ✅", "success");
  };

  const saveProcEdit = () => {
    if (!editProcItem) return;
    setProcCategories((prev) =>
      prev.map((cat) =>
        cat.id === editProcItem.catId ? {
          ...cat,
          items: cat.items.map((i) =>
            i.id === editProcItem.id ? { ...i, name: editProcName, nameAr: editProcNameAr, unit: editProcUnit } : i
          )
        } : cat
      )
    );
    setEditProcItem(null);
    showToast("Item updated! ✅", "success");
  };

  const deleteProcItem = (catId, itemId) => {
    setProcCategories((prev) =>
      prev.map((cat) =>
        cat.id === catId ? { ...cat, items: cat.items.filter((i) => i.id !== itemId) } : cat
      )
    );
    showToast("Item deleted!", "success");
  };

  const [addCatModal, setAddCatModal] = useState(false);
  const [newCatName, setNewCatName] = useState("");
  const [newCatNameAr, setNewCatNameAr] = useState("");
  const [newCatEmoji, setNewCatEmoji] = useState("📦");
  const [newCatUnit, setNewCatUnit] = useState("kg");

  const saveNewCategory = () => {
    if (!newCatName) return;
    const newCat = {
      id: genId(),
      name: newCatName,
      nameAr: newCatNameAr,
      emoji: newCatEmoji,
      unit: newCatUnit,
      items: [],
    };
    setProcCategories((prev) => [...prev, newCat]);
    setAddCatModal(false);
    setNewCatName(""); setNewCatNameAr(""); setNewCatEmoji("📦"); setNewCatUnit("kg");
    showToast("Category added! ✅", "success");
  };

  const openEdit = (catId, item) => {
    setEditItem({ catId, ...item });
    setEditPrice(item.price.toString());
    setEditName(item.name);
    setEditNameAr(item.nameAr || "");
  };

  const saveEdit = () => {
    if (!editItem) return;
    setMenuCategories((prev) =>
      prev.map((cat) =>
        cat.id === editItem.catId ? {
          ...cat,
          items: cat.items.map((i) =>
            i.id === editItem.id ? { ...i, name: editName, nameAr: editNameAr, price: Number(editPrice) } : i
          )
        } : cat
      )
    );
    setEditItem(null);
    showToast("Item updated! ✅", "success");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ fontSize: 22, fontWeight: 800 }}>⚙️ Settings</div>
      <div style={{ display: "flex", gap: 8 }}>
        <Pill label="🥙 Menu Items" active={settingsTab === "menu"} onClick={() => setSettingsTab("menu")} />
        <Pill label="📦 Procurement Items" active={settingsTab === "procurement"} onClick={() => setSettingsTab("procurement")} />
      </div>

      {settingsTab === "menu" && menuCategories.map((cat) => (
        <div key={cat.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontWeight: 700 }}>{cat.emoji} {cat.name}</div>
            <button onClick={() => setAddItemModal(cat.id)} style={{ background: T.accent, border: "none", color: T.white, borderRadius: 8, padding: "6px 14px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 700 }}>+ Add Item</button>
          </div>
          {cat.items.map((item) => (
            <div key={item.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: `1px solid ${T.border}30` }}>
              <div>
                <div style={{ fontWeight: 600 }}>{item.name}</div>
                <div style={{ color: T.muted, fontSize: 12 }}>{item.nameAr}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontFamily: "monospace", fontWeight: 800, color: T.accent }}>{item.price} LYD</span>
                <button onClick={() => openEdit(cat.id, item)} style={{ background: T.card, border: `1px solid ${T.border}`, color: T.text, borderRadius: 8, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>✏️ Edit</button>
                <button onClick={() => {
                  setMenuCategories((prev) =>
                    prev.map((c) => c.id === cat.id ? { ...c, items: c.items.filter((i) => i.id !== item.id) } : c)
                  );
                  showToast("Item deleted!", "success");
                }} style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      ))}

{addItemModal && (
        <Modal title={`Add New Item — ${menuCategories.find((c) => c.id === addItemModal)?.name}`} onClose={() => { setAddItemModal(null); setNewItemName(""); setNewItemNameAr(""); setNewItemPrice(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Item Name (English)" value={newItemName} onChange={(e) => setNewItemName(e.target.value)} placeholder="e.g. Falafel Special" />
            <Input label="Item Name (Arabic)" value={newItemNameAr} onChange={(e) => setNewItemNameAr(e.target.value)} placeholder="e.g. فلافل سبيشال" />
            <Input label="Price (LYD)" type="number" value={newItemPrice} onChange={(e) => setNewItemPrice(e.target.value)} placeholder="0" />
            <Btn onClick={saveNewItem} full>Add Item</Btn>
          </div>
        </Modal>
      )}

      {settingsTab === "procurement" && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button onClick={() => setAddCatModal(true)} style={{ background: T.accent, border: "none", color: T.white, borderRadius: 8, padding: "8px 18px", cursor: "pointer", fontSize: 13, fontFamily: "inherit", fontWeight: 700 }}>+ Add Category</button>
        </div>
      )}

      {settingsTab === "procurement" && procCategories.map((cat) => (
        <div key={cat.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontWeight: 700 }}>{cat.emoji} {cat.name}</div>
            <button onClick={() => setAddProcItemModal(cat.id)} style={{ background: T.accent, border: "none", color: T.white, borderRadius: 8, padding: "6px 14px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 700 }}>+ Add Item</button>
          </div>
          {cat.items.map((item) => (
            <div key={item.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: `1px solid ${T.border}30` }}>
              <div>
                <div style={{ fontWeight: 600 }}>{item.name}</div>
                <div style={{ color: T.muted, fontSize: 12 }}>{item.nameAr}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button onClick={() => { setEditProcItem({ catId: cat.id, ...item }); setEditProcName(item.name); setEditProcNameAr(item.nameAr || ""); setEditProcUnit(item.unit || "kg"); }}
                  style={{ background: T.card, border: `1px solid ${T.border}`, color: T.text, borderRadius: 8, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>✏️ Edit</button>
                <button onClick={() => deleteProcItem(cat.id, item.id)}
                  style={{ background: T.red + "22", border: `1px solid ${T.red}`, color: T.red, borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      ))}

      {addCatModal && (
        <Modal title="Add New Procurement Category" onClose={() => { setAddCatModal(false); setNewCatName(""); setNewCatNameAr(""); setNewCatEmoji("📦"); setNewCatUnit("kg"); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Category Name (English)" value={newCatName} onChange={(e) => setNewCatName(e.target.value)} placeholder="e.g. Meat" />
            <Input label="Category Name (Arabic)" value={newCatNameAr} onChange={(e) => setNewCatNameAr(e.target.value)} placeholder="e.g. لحوم" />
            <Input label="Emoji" value={newCatEmoji} onChange={(e) => setNewCatEmoji(e.target.value)} placeholder="e.g. 🥩" />
            <Select label="Unit" value={newCatUnit} onChange={(e) => setNewCatUnit(e.target.value)}>
              <option value="kg">kg</option>
              <option value="pcs">pcs</option>
              <option value="L">L (Liters)</option>
              <option value="box">box</option>
              <option value="bag">bag</option>
              <option value="unit">unit</option>
            </Select>
            <Btn onClick={saveNewCategory} full>Add Category</Btn>
          </div>
        </Modal>
      )}

      {addProcItemModal && (
        <Modal title={`Add Item — ${procCategories.find((c) => c.id === addProcItemModal)?.name}`} onClose={() => { setAddProcItemModal(null); setNewProcName(""); setNewProcNameAr(""); }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Item Name (English)" value={newProcName} onChange={(e) => setNewProcName(e.target.value)} placeholder="e.g. Tomato Paste" />
            <Input label="Item Name (Arabic)" value={newProcNameAr} onChange={(e) => setNewProcNameAr(e.target.value)} placeholder="e.g. معجون طماطم" />
            <Btn onClick={saveNewProcItem} full>Add Item</Btn>
          </div>
        </Modal>
      )}

      {editProcItem && (
        <Modal title={`Edit — ${editProcItem.name}`} onClose={() => setEditProcItem(null)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Item Name (English)" value={editProcName} onChange={(e) => setEditProcName(e.target.value)} />
            <Input label="Item Name (Arabic)" value={editProcNameAr} onChange={(e) => setEditProcNameAr(e.target.value)} />
            <Select label="Unit" value={editProcUnit} onChange={(e) => setEditProcUnit(e.target.value)}>
              <option value="kg">kg</option>
              <option value="pcs">pcs</option>
              <option value="L">L (Liters)</option>
              <option value="box">box</option>
              <option value="bag">bag</option>
              <option value="unit">unit</option>
            </Select>
            <Btn onClick={saveProcEdit} full>Save Changes</Btn>
          </div>
        </Modal>
      )}

      {editItem && (
        <Modal title={`Edit — ${editItem.name}`} onClose={() => setEditItem(null)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Item Name (English)" value={editName} onChange={(e) => setEditName(e.target.value)} />
            <Input label="Item Name (Arabic)" value={editNameAr} onChange={(e) => setEditNameAr(e.target.value)} />
            <Input label="Price (LYD)" type="number" value={editPrice} onChange={(e) => setEditPrice(e.target.value)} />
            <Btn onClick={saveEdit} full>Save Changes</Btn>
          </div>
        </Modal>
      )}
    
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN APP
// ═══════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [page, setPage] = useState("dashboard");
  const [role, setRole] = useState(() => sessionStorage.getItem("fab_role") || null);
  const [loginInput, setLoginInput] = useState("");
  const [loginError, setLoginError] = useState("");
  const [salesRecords, setSalesRecords] = useStore("fab_sales", {});
  const [procRecords, setProcRecords] = useStore("fab_proc", {});
  const [wageRecords, setWageRecords] = useStore("fab_wages", {});
  const [monthlyExpenses, setMonthlyExpenses] = useStore("fab_monthly", []);
  const [menuCategories, setMenuCategories] = useStore("fab_menu", MENU_CATEGORIES);
  const [prestoPayments, setPrestoPayments] = useStore("fab_presto_payments", []);
  const [procurementCategories, setProcurementCategories] = useStore("fab_proc_cats", PROCUREMENT_CATEGORIES);
  const [staff, setStaff] = useStore("fab_staff", INITIAL_STAFF);
  const [settings] = useState({ prestoCommission: 20, currency: "LYD" });
  const [toast, setToast] = useState(null);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleLogin = () => {
    const r = PASSWORDS[loginInput.trim()];
    if (r) {
      sessionStorage.setItem("fab_role", r);
      setRole(r);
      setLoginError("");
    } else {
      setLoginError("Incorrect password. Please try again.");
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("fab_role");
    setRole(null);
    setLoginInput("");
  };

  if (!role) return (
    <div style={{ background: T.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 20, padding: 40, width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.5)" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🧆</div>
          <div style={{ fontWeight: 900, fontSize: 22, color: T.text }}>Falafel Al Bayt</div>
          <div style={{ color: T.accent, fontSize: 12, fontWeight: 700, letterSpacing: 1.5 }}>BUSINESS MANAGER</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: T.muted, letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={loginInput}
              onChange={(e) => setLoginInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              style={{ background: T.surface, border: `1px solid ${loginError ? T.red : T.border}`, borderRadius: 10, color: T.text, padding: "12px 16px", fontSize: 15, outline: "none", width: "100%", boxSizing: "border-box", fontFamily: "inherit" }}
            />
            {loginError && <div style={{ color: T.red, fontSize: 12, marginTop: 6 }}>{loginError}</div>}
          </div>
          <button onClick={handleLogin} style={{ background: T.accent, color: "#fff", border: "none", borderRadius: 10, padding: "13px", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: "inherit", boxShadow: `0 0 20px ${T.accent}55` }}>
            Login
          </button>
        </div>
      </div>
    </div>
  );

  const NAV = [
    { id: "dashboard",   label: "Dashboard",      icon: "📊" },
    { id: "reports",     label: "Analytical Reports", icon: "📈" },
    { id: "sales",       label: "Sales",          icon: "🧾" },
    { id: "procurement", label: "Procurement",    icon: "📦" },
    { id: "wages",       label: "Wages & Staff",  icon: "👷" },
    { id: "monthly",     label: "Monthly",        icon: "🏢" },
    { id: "history",     label: "History",        icon: "📋" },
    { id: "presto",      label: "Presto",         icon: "🛵" },
    { id: "settings",    label: "Settings",       icon: "⚙️" },
  ];

  return (
    <div style={{ background: T.bg, minHeight: "100vh", fontFamily: "'Inter', system-ui, sans-serif", color: T.text }}>
      {/* TOP BAR */}
      <div style={{ background: T.surface, borderBottom: `1px solid ${T.border}`, position: "sticky", top: 0, zIndex: 200, boxShadow: "0 2px 20px rgba(0,0,0,0.4)" }}>
        <div style={{ maxWidth: 1800, margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 58 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 26 }}>🧆</span>
            <div>
              <div style={{ fontWeight: 900, fontSize: 15, letterSpacing: -0.5, lineHeight: 1 }}>Falafel Al Bayt</div>
              <div style={{ color: T.accent, fontSize: 10, fontWeight: 700, letterSpacing: 1.5 }}>BUSINESS MANAGER</div>
            </div>
          </div>
          <nav style={{ display: "flex", gap: 2 }} className="desktop-nav">
            {NAV.map((n) => (
              <button key={n.id} onClick={() => setPage(n.id)} style={{
                background: page === n.id ? T.accent + "22" : "transparent",
                color: page === n.id ? T.accentLight : T.muted,
                border: "none", borderRadius: 10, padding: "7px 13px",
                cursor: "pointer", fontWeight: 600, fontSize: 12,
                display: "flex", alignItems: "center", gap: 5, fontFamily: "inherit",
                borderBottom: page === n.id ? `2px solid ${T.accent}` : "2px solid transparent",
              }}>
                <span>{n.icon}</span><span>{n.label}</span>
              </button>
            ))}
          </nav>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ fontSize: 12, color: T.muted, fontFamily: "monospace" }}>
              {new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
            </div>
            {role === "admin" && <span style={{ fontSize: 10, fontWeight: 700, color: T.green, background: T.green + "22", padding: "3px 8px", borderRadius: 99, border: `1px solid ${T.green}44` }}>ADMIN</span>}
            {role === "viewer" && <span style={{ fontSize: 10, fontWeight: 700, color: T.yellow, background: T.yellow + "22", padding: "3px 8px", borderRadius: 99, border: `1px solid ${T.yellow}44` }}>VIEW ONLY</span>}
            <button onClick={handleLogout} style={{ background: T.card, border: `1px solid ${T.border}`, color: T.muted, borderRadius: 8, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: 600 }}>Logout</button>
          </div>
        </div>
      </div>

      {/* MOBILE BOTTOM NAV */}
      <div className="mobile-nav" style={{
        position: "fixed", bottom: 0, left: 0, right: 0,
        background: T.surface, borderTop: `1px solid ${T.border}`,
        display: "none", zIndex: 200, padding: "6px 0 8px",
        justifyContent: "space-around",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.4)",
      }}>
        {NAV.map((n) => (
          <button key={n.id} onClick={() => setPage(n.id)} style={{
            background: "none", border: "none",
            color: page === n.id ? T.accentLight : T.muted,
            cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
            padding: "4px 8px", fontFamily: "inherit",
          }}>
            <span style={{ fontSize: 20 }}>{n.icon}</span>
            <span style={{ fontSize: 9, fontWeight: 700 }}>{n.label}</span>
          </button>
        ))}
      </div>

      {/* CONTENT */}
      <div style={{ maxWidth: 1800, margin: "0 auto", padding: "24px 24px 90px" }}>
        {role === "viewer" && (
          <div style={{ background: T.yellow + "22", border: `1px solid ${T.yellow}`, borderRadius: 12, padding: "10px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 16 }}>👁</span>
            <span style={{ color: T.yellow, fontWeight: 700, fontSize: 13 }}>View Only Mode — You can browse but cannot make any changes</span>
          </div>
        )}
        {page === "dashboard" && <Dashboard salesRecords={salesRecords} procRecords={procRecords} wageRecords={wageRecords} monthlyExpenses={monthlyExpenses} staff={staff} settings={settings} menuCategories={menuCategories} />}
        {page === "sales" && <SalesEntry salesRecords={salesRecords} setSalesRecords={setSalesRecords} settings={settings} showToast={showToast} menuCategories={menuCategories} role={role} />}
        {page === "procurement" && <ProcurementEntry procRecords={procRecords} setProcRecords={setProcRecords} showToast={showToast} role={role} procurementCategories={procurementCategories} />}
        {page === "wages" && <WagesStaff staff={staff} setStaff={setStaff} wageRecords={wageRecords} setWageRecords={setWageRecords} showToast={showToast} role={role} />}
        {page === "monthly" && <MonthlyExpenses monthlyExpenses={monthlyExpenses} setMonthlyExpenses={setMonthlyExpenses} staff={staff} setStaff={setStaff} showToast={showToast} role={role} />}
        {page === "history" && <History salesRecords={salesRecords} procRecords={procRecords} wageRecords={wageRecords} role={role} setSalesRecords={setSalesRecords} setProcRecords={setProcRecords} setWageRecords={setWageRecords} showToast={showToast} />}
        {page === "reports" && <Reports salesRecords={salesRecords} procRecords={procRecords} wageRecords={wageRecords} monthlyExpenses={monthlyExpenses} staff={staff} menuCategories={menuCategories} procurementCategories={procurementCategories} />}
        {page === "presto" && <Presto salesRecords={salesRecords} menuCategories={menuCategories} prestoPayments={prestoPayments} setPrestoPayments={setPrestoPayments} showToast={showToast} role={role} />}
        {page === "settings" && role === "admin" && <Settings menuCategories={menuCategories} setMenuCategories={setMenuCategories} procurementCategories={procurementCategories} setProcurementCategories={setProcurementCategories} staff={staff} setStaff={setStaff} showToast={showToast} />}
        {page === "settings" && role === "viewer" && <div style={{ textAlign: "center", padding: 60, color: T.muted }}>⚠️ You don't have permission to access Settings.</div>}
      </div>

      {toast && <Toast msg={toast.msg} type={toast.type} />}

      <style>{`
        * { box-sizing: border-box; }
        .proc-item:hover { background: rgba(251, 191, 36, 0.2) !important; }
        input[type=number]::-webkit-outer-spin-button,
        input[type=number]::-webkit-inner-spin-button { -webkit-appearance: none; }
        input[type=date]::-webkit-calendar-picker-indicator { filter: invert(0.5) sepia(1) saturate(2) hue-rotate(190deg); }
        input[type=month]::-webkit-calendar-picker-indicator { filter: invert(0.5) sepia(1) saturate(2) hue-rotate(190deg); }
        select option { background: #223259; }
        ::-webkit-scrollbar { width: 4px; height: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #3A5080; border-radius: 99px; }
        @media (max-width: 640px) {
          .desktop-nav { display: none !important; }
          .mobile-nav  { display: flex !important; overflow-x: scroll !important; -webkit-overflow-scrolling: touch !important; scrollbar-width: none !important; }
          .mobile-nav::-webkit-scrollbar { display: none !important; }
          .mobile-nav button { min-width: 64px !important; flex-shrink: 0 !important; padding: 4px 6px !important; }
          .mobile-nav button span:first-child { font-size: 20px !important; }
          .mobile-nav button span:last-child { font-size: 8px !important; line-height: 1.2 !important; text-align: center !important; }
        }
        ${role === "viewer" ? `
          input, select, textarea { pointer-events: none !important; opacity: 0.7 !important; }
        ` : ""}
      `}</style>
    </div>
  );
}